//集中项目所有接口的apis.js

import axios from "./$http";
import base from "./base";

const apis = {
  //获取全部区域
  getAllRegion(paramsData) {
    return axios.get(`/develop/my/static/allRegion`, { params: paramsData });
  },
  //判断当前项目是否属于
  owenProject(paramsData) {
    return axios.get(`/develop/workbench/owenProject`, { params: paramsData });
  },
  //工作台获取项目信息
  workbenchgetProjectList(paramsData) {
    return axios.get(`/develop/workbench/getProjectList`, paramsData);
  },
  //提交意见与反馈
  addFeedBack(paramsData) {
    return axios.post(`/develop/feedback/add`, paramsData);
  },
  //查询日志列表
  dailyRecordList(paramsData) {
    return axios.post(`/develop/my/daily/list`, paramsData);
  },
  //查询我的日志列表
  myDailyRecordList(paramsData) {
    return axios.post(`/develop/my/daily/myList`, paramsData);
  },
  //查询点评人
  ReplyList(paramsData) {
    return axios.post(`/develop/my/staff/searchReply`, paramsData);
  },
  //添加日志
  adddaily(paramsData) {
    return axios.post(`/develop/my/daily/add`, paramsData);
  },
  //获取日志详情
  getdaily(paramsData) {
    return axios.get(`/develop/my/daily/get`, { params: paramsData });
  },
  //编辑日志
  editdaily(paramsData) {
    return axios.post(`/develop/my/daily/update`, paramsData);
  },
  //获取日志分类列表
  getDailyLogType(paramsData) {
    return axios.get(`/develop/my/daily/getDailyLogType`, {
      params: paramsData
    });
  },
  //获取职位
  getroleInfo(paramsData) {
    return axios.get(`/develop/my/daily/roleInfo`, { params: paramsData });
  },
  //条件查询项目列表
  projectList(paramsData) {
    return axios.post(`/develop/project/manage/projectList`, paramsData);
  },
  //查询本公司所有开发商
  allDeveloper(paramsData) {
    return axios.get(`/develop/developer/allDeveloper`, { params: paramsData });
  },
  //新增开发商
  addDeveloper(paramsData) {
    return axios.post(`/develop/developer/add`, paramsData);
  },
  //获取资源列表
  getResourceList(paramsData) {
    return axios.post(`/develop/resource/manage/list`, paramsData);
  },
  //获取开发商资源列表
  queryResource(paramsData) {
    return axios.get(`/develop/developer/follow/queryResource`, {
      params: paramsData
    });
  },
  //获取开发商资源列表
  isCalled(paramsData) {
    return axios.get(`/develop/resource/manage/isCalled`, {
      params: paramsData
    });
  },
  //获取开发商项目列表
  queryProject(paramsData) {
    return axios.get(`/develop/developer/follow/queryProject`, {
      params: paramsData
    });
  },
  //跟进开发商
  saveDeveloperFollow(paramsData) {
    return axios.post(`/develop/developer/follow/saveFollow`, paramsData);
  },
  //获取开发商跟进记录
  getDeveloperFollowList(paramsData) {
    return axios.get(`/develop/developer/follow/followList`, {
      params: paramsData
    });
  },
  //获取资源详情
  getResourceDetail(paramsData) {
    return axios.get(`/develop/resource/manage/get`, { params: paramsData });
  },
  //资源查看记录
  viewLog(paramsData) {
    return axios.get(`/develop/resource/manage/viewLog`, {
      params: paramsData
    });
  },
  //新增资源
  addResource(paramsData) {
    return axios.post(`/develop/resource/manage/add`, paramsData);
  },
  //更新资源
  updateResource(paramsData) {
    return axios.post(`/develop/resource/manage/update`, paramsData);
  },
  //获取跟进资源列表
  getFollowList(paramsData) {
    return axios.post(`/develop/resource/follow/pendRecord`, paramsData);
  },
  //获取跟进资源详情
  getResFollowDetail(paramsData) {
    return axios.get(`/develop/resource/follow/followRecordDetail`, {
      params: paramsData
    });
  },
  //查询待跟进资源列表
  getWaitFollowResList(paramsData) {
    return axios.post(`/develop/pending/resource/resourceList`, paramsData);
  },
  //获取跟进资源详情 资源ID查询资源跟进详情
  getFollowDetail(paramsData) {
    return axios.get(`/develop/resource/follow/followDetail`, {
      params: paramsData
    });
  },
  //查询本公司所有物业
  allProperty(paramsData) {
    return axios.get(`/develop/property/allDeveloper`, { params: paramsData });
  },
  //新增物业
  addProperty(paramsData) {
    return axios.post(`/develop/property/add`, paramsData);
  },
  //查询项目修改记录
  getUpdateRecord(paramsData) {
    return axios.get(`/develop/project/manage/updateRecord`, {
      params: paramsData
    });
  },
  //查询所有拓展人员
  getExpandStaff(paramsData) {
    return axios.get(`/develop/project/manage/expandStaff`, {
      params: paramsData
    });
  },
  //查询项目信息
  getProjectDetail(paramsData) {
    return axios.get(`/develop/project/manage/projectDetail`, {
      params: paramsData
    });
  },
  //新增待跟进
  todoAddProject(paramsData) {
    return axios.post(`/develop/pending/project/todoAdd`, paramsData);
  },
  //查询待跟进项目详情
  getProjectFollowDetail(paramsData) {
    return axios.get(`/develop/pending/project/projectDetail`, {
      params: paramsData
    });
  },
  //修改项目详情
  updateProject(paramsData) {
    return axios.post(`/develop/project/manage/updateProject`, paramsData);
  },
  //新建项目
  createProject(paramsData) {
    return axios.post(`/develop/project/manage/createProject`, paramsData);
  },
  //提交项目跟进
  projectFollowAdd(paramsData) {
    return axios.post(`/develop/pending/project/followAdd`, paramsData);
  },
  //项目ID写跟进查询
  getProjectfollowDetail(paramsData) {
    return axios.get(`/develop/project/follow/followDetail`, {
      params: paramsData
    });
  },
  //跟进记录列表查询
  projectPendRecord(paramsData) {
    return axios.post(`/develop/project/follow/pendRecord`, paramsData);
  },
  //新跟进记录列表查询
  projectFollowListRecord(paramsData) {
    return axios.post(`/develop/project/follow/followList`, paramsData);
  },
  //添加资源跟进
  followAdd(paramsData) {
    return axios.post(`/develop/pending/resource/followAdd`, paramsData);
  },
  //结束资源跟进
  finishFollow(paramsData) {
    return axios.post(`/develop/pending/resource/finishFollow`, paramsData);
  },
  //获取拓展人员的礼品列表
  getGiftList(paramsData) {
    return axios.get(`/develop/resource/gift/giftList`, { params: paramsData });
  },
  //获取当前礼品列表
  getSendGiftList(paramsData) {
    return axios.post(`/develop/resource/gift/sendList`, paramsData);
  },
  //资源退还接口
  rejectGift(paramsData) {
    return axios.post(`/develop/resource/gift/rejectGift`, paramsData);
  },
  //添加礼物
  addSendGift(paramsData) {
    return axios.post(`/develop/resource/gift/add`, paramsData);
  },
  //文件上传
  fileUpload(paramsData) {
    // return axios.post(`http://192.168.1.154:9803/upload/upload/file`, paramsData);
    return axios.post(base.uploadUrl + `/upload/upload/file`, paramsData);
  },
  //查询跟进记录详情
  getFollowRecordDetail(paramsData) {
    return axios.get(`/develop/project/follow/followRecordDetail`, {
      params: paramsData
    });
  },
  //查询项目商务条款详情
  getBusDetail(paramsData) {
    return axios.get(`/develop/project/process/busDetail`, {
      params: paramsData
    });
  },
  //保存商务条款文件地址并将流程更新为审批条款
  uploadBusFileSave(paramsData) {
    return axios.post(`/develop/project/process/busFileSave`, paramsData);
  },
  //查询待跟进项目列表
  waitProjectFollowList(paramsData) {
    return axios.post(`/develop/pending/project/followList`, paramsData);
  },
  //查询待审批商务条款列表
  waitClauseFollowList(paramsData) {
    return axios.post(`/develop/pending/business/followList`, paramsData);
  },
  //查询待审批商务条款详情
  getFollowClauseDetail(paramsData) {
    return axios.get(`/develop/pending/business/followDetail`, {
      params: paramsData
    });
  },
  //执行商务条款审批流程
  auditClauseFollowAdd(paramsData) {
    return axios.post(`/develop/pending/business/followAdd`, paramsData);
  },
  //提前结束项目
  endProject(paramsData) {
    return axios.post(`/develop/project/process/endProject`, paramsData);
  },
  //查询待审批合同列表
  waitagreementFollowList(paramsData) {
    return axios.post(`/develop/pending/contract/followList`, paramsData);
  },
  //查询待审批合同详情
  getFollowAgreementDetail(paramsData) {
    return axios.get(`/develop/pending/contract/followDetail`, {
      params: paramsData
    });
  },
  //执行合同审批流程
  auditAgreementFollowAdd(paramsData) {
    return axios.post(`/develop/pending/contract/followAdd`, paramsData);
  },
  //数据统计查询
  getStaticData(paramsData) {
    return axios.post(`/develop/my/static/get`, paramsData);
  },
  //查询项目警示信息
  getWarnInfo(paramsData) {
    return axios.get(`/develop/project/manage/warnInfo`, {
      params: paramsData
    });
  },
  //结束项目跟进
  finishProjectFollow(paramsData) {
    return axios.post(`/develop/pending/project/finishFollow`, paramsData);
  },
  //保存合同文件地址并将流程更新为审批合同
  contractFileSave(paramsData) {
    return axios.post(`/develop/project/process/contractFileSave`, paramsData);
  },
  //查询待处理任务数量统计
  getPendingStatic(paramsData) {
    return axios.get(`/develop/pending/project/pendingStatic`, {
      params: paramsData
    });
  },
  //获取待接收列表
  acceptedReserve(paramsData) {
    return axios.get(`/develop/resource/gift/acceptedReserve`, {
      params: paramsData
    });
  },
  //个人库存接收
  addReceive(paramsData) {
    return axios.post(`/develop/resource/gift/receive`, paramsData);
  },
  //更新用户头像
  updateUserInfo(paramsData) {
    return axios.post(`/develop/my/staff/update`, paramsData);
  },
  //修改密码
  updatePwd(paramsData) {
    return axios.post(`/develop/my/staff/updatePwd`, paramsData);
  },
  //新增标签
  addTag(paramsData) {
    return axios.post(`/develop/project/tag/add`, paramsData);
  },
  //查询所有标签
  getAllTag(paramsData) {
    return axios.get(`/develop/project/tag/all`, { params: paramsData });
  },
  //绑定标签
  bindTag(paramsData) {
    return axios.post(`/develop/project/tag/bind`, paramsData);
  },
  //消息列表
  msgList(paramsData) {
    return axios.post(`/develop/message/list`, paramsData);
  },
  //消息面板统计
  msgUnread(paramsData) {
    return axios.get(`/develop/my/static/unread`, { params: paramsData });
  },
  //消息变更为已读
  msgRead(paramsData) {
    return axios.post(`/develop/message/read`, paramsData);
  },
  //我的意见与反馈列表
  feedBackList(paramsData) {
    return axios.post(`/develop/feedback/list`, paramsData);
  },
  //意见与反馈详情
  feedBackDetail(paramsData) {
    return axios.get(`/develop/feedback/detail`, { params: paramsData });
  },
  //意见反馈变更为已读
  feedbackRead(paramsData) {
    return axios.get(`/develop/feedback/read`, { params: paramsData });
  },
  //提交建议反馈
  submitFeedback(paramsData) {
    return axios.post(`/develop/feedback/resolve`, paramsData);
  },
  //公告列表
  noticeList(paramsData) {
    return axios.post(`/develop/announcement/list`, paramsData);
  },
  //公告详情
  noticeDetail(paramsData) {
    return axios.post(`/develop/announcement/detail`, paramsData);
  },
  //公告变更为已读
  noticeRead(paramsData) {
    return axios.post(`/develop/announcement/read`, paramsData);
  },
  //首页是否弹出公告
  noticeIsPopup(paramsData) {
    return axios.post(`/develop/announcement/popup`, paramsData);
  },
  //首页是否弹出抵押
  pendingMortgageInfo(paramsData) {
    return axios.get(`/develop/ContractMortgage/pendingMortgageInfo`, {
      params: paramsData
    });
  },
  //消息统计
  commonData(paramsData) {
    return axios.get(`/develop/my/static/commonData`, { params: paramsData });
  },
  //是否写日志
  isWriteDailyRecord(paramsData) {
    return axios.get(`/develop/my/daily/isWrite`, { params: paramsData });
  },
  //号外号在线呼叫
  tHwhCall(paramsData) {
    return axios.post(base.phoneUrl + `/call/call`, paramsData);
  },
  //号外号绑定
  registerPhone(phone) {
    return axios.post(`/develop/tHwh/register/${phone}`);
  },
  //查询员工详情
  getStaffInfo(paramsData) {
    return axios.get(`/develop/my/staff/get`, { params: paramsData });
  },
  //更新用户头像
  updateUserInfo(paramsData) {
    return axios.post(`/develop/my/staff/update`, paramsData);
  },
  //申请项目分享
  projectShare(paramsData) {
    return axios.post(`/develop/project/manage/projectShare`, paramsData);
  },
  //同意或不同意分享项目
  projectShareAction(paramsData) {
    return axios.post(`/develop/project/manage/projectShareAction`, paramsData);
  },
  // //获取收款公司列表
  // ourCompanyList(paramsData) {
  //     return axios.get(`/develop/collectionAccount/list`, { params: paramsData });
  // },
  //遗失报备
  lostGift(paramsData) {
    return axios.post(`/develop/resource/gift/lost`, paramsData);
  },
  //库存信息转移
  reserveOut(paramsData) {
    return axios.post(`/develop/resource/gift/reserveOut`, paramsData);
  },
  //项目选择关联资源列表
  queryByProjectId(paramsData) {
    return axios.post(`/develop/resource/manage/queryByProjectId`, paramsData);
  },
  //资源选择关联项目列表
  projectListByResourceId(paramsData) {
    return axios.post(
      `/develop/project/manage/projectListByResourceId`,
      paramsData
    );
  },
  //工作台通话记录
  callList(paramsData) {
    return axios.post(`/develop/project/manage/callList`, paramsData);
  },
  //工作台通话记录
  projectAndResourceCall(paramsData) {
    return axios.get(`/develop/project/manage/projectAndResourceCall`, {
      params: paramsData
    });
  },
  //消息全部已读
  allRead(paramsData) {
    return axios.post(`/develop/message/allRead`, paramsData);
  },
  //获取打分表
  scoringDetail(paramsData) {
    return axios.get("/develop/scoring/web/detail", { params: paramsData });
  },
  //获取打分列表
  scoringList(paramsData) {
    return axios.get("/develop/scoring/list", { params: paramsData });
  },
  //提交打分表
  postScore(paramsData) {
    return axios.post("/develop/scoring/web/submit", paramsData);
  },
  //获取公司所有人员
  getCompanyPersons(paramsData) {
    return axios.post("/develop/scoring/web/staff/list", paramsData);
  },
  //获取公司所有人员
  getTeamAndProject(paramsData) {
    return axios.get("/develop/scoring/web/getTeamAndProject", {
      params: paramsData
    });
  },
  //获取打分记录
  getRecordScoreList(paramsData) {
    return axios.post("/develop/scoring/record/list", paramsData);
  },
  //获取打分详情
  scoredDetail(paramsData) {
    return axios.get("/develop/scoring/web/record/detail", {
      params: paramsData
    });
  },
  //获取销售业主列表
  selectSaleCustomer(paramsData) {
    return axios.get("/develop/workbench/selectSaleCustomer", {
      params: paramsData
    });
  },
  //获取短链接
  getLinkAddress(paramsData) {
    return axios.get("/develop/scoring/web/linkAddress", {
      params: paramsData
    });
  },
  //克隆项目
  copyProject(paramsData) {
    return axios.post("/develop/project/manage/copyProject", paramsData);
  },
  //全部送礼记录
  getAllSendGiftList(paramsData) {
    return axios.post(`/develop/resource/gift/sendList`, paramsData);
  },
  //资源修改记录
  resourceUpdateRecord(paramsData) {
    return axios.post("/resource/manage/updateRecord", paramsData);
  },
  //项目事件轴
  eventAxis(paramsData) {
    return axios.get("/develop/project/manage/eventAxis", {
      params: paramsData
    });
  },
  //资源修改记录
  resourceUpdateRecord(paramsData) {
    return axios.get("/develop/resource/manage/updateRecord", {
      params: paramsData
    });
  },
  //获取期数
  getNumberPeriods(paramsData) {
    return axios.get("/develop/customer/getNumberPeriods", {
      params: paramsData
    });
  },
  //新增修改结算单
  addOrUpdate(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/addOrUpdate",
      paramsData
    );
  },
  //新增修改结算单
  addSettle(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/add",
      paramsData
    );
  },
  //修改结算单
  updateSettle(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/update",
      paramsData
    );
  },
  //结算列表
  settlementList(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/list",
      paramsData
    );
  },
  //结算详情
  settlementDetail(paramsData) {
    return axios.get(base.settlementUrl + "/settlement/settlement/detail", {
      params: paramsData
    });
  },
  //删除
  settlementDelete(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/delete",
      paramsData
    );
  },
  //新增推荐人
  settlementRecommend(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/recommend",
      paramsData
    );
  },
  //copy结算单
  settlementCopy(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/copy",
      paramsData
    );
  },
  //结算单审核列表
  checkSettlementStateList(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/checkStateList",
      paramsData
    );
  },
  //结算单审核通过不通过
  settlementCheckState(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/checkState",
      paramsData
    );
  },
  //通过结算人获取次结算人
  getSettlementNameTwo(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/getSettlementNameTwo",
      paramsData
    );
  },
  //待结算数量
  settlementCount(paramsData) {
    return axios.get(base.settlementUrl + "/settlement/settlement/count", {
      params: paramsData
    });
  },
  //删除项目
  deleteProject(paramsData) {
    return axios.post("/develop/project/manage/deleteProject", paramsData);
  },
  //项目详情-打分表
  projectRecord(paramsData) {
    return axios.post("/develop/scoring/projectRecord", paramsData);
  },
  //获取用户当天打卡信息
  currentList(paramsData) {
    return axios.get("/develop/clockOn/currentList", { params: paramsData });
  },
  //新增打卡
  addPunchClock(paramsData) {
    return axios.post("/develop/clockOn/add", paramsData);
  },
  //条件查询打卡列表
  punchClockList(paramsData) {
    return axios.post("/develop/clockOn/list", paramsData);
  },
  //查询打卡统计信息
  clockStatistics(paramsData) {
    return axios.post("/develop/clockOn/clockStatistics", paramsData);
  },
  //查询打卡统计信息列表
  clockStatisticsList(paramsData) {
    return axios.post("/develop/clockOn/clockStatisticsList", paramsData);
  },
  //项目成员打卡记录列表
  projectPunchClock(paramsData) {
    return axios.get("/develop/project/clockOn/list", { params: paramsData });
  },
  //新增项目打卡
  addProjectPunchClock(paramsData) {
    return axios.post("/develop/project/clockOn/add", paramsData);
  },
  //查询当前是否可以打卡
  isClock(paramsData) {
    return axios.get("/develop/clockOn/isClock", { params: paramsData });
  },
  //首页是否去打卡
  isEffectiveClock(paramsData) {
    return axios.get("/develop/clockOn/isEffectiveClock", {
      params: paramsData
    });
  },
  //获取所有经理团队
  getAllManager(paramsData) {
    return axios.get(`/develop/team/allManager`, { params: paramsData });
  },
  //项目库存记录
  reserveLogList(paramsData) {
    return axios.get("/develop/resource/gift/reserveLog", {
      params: paramsData
    });
  },
  //获取文件模版
  projectFileTemplate(paramsData) {
    return axios.get("/develop/project/manage/projectFileTemplate", {
      params: paramsData
    });
  },
  //获取关系图
  getResourceRelationship(paramsData) {
    return axios.get("/develop/resource/manage/getResourceRelationship", {
      params: paramsData
    });
  },
  //获取打卡位置
  getLocation(paramsData) {
    return axios.get("/develop/clockOn/getLocation", { params: paramsData });
  },
  //查询开发商列表
  selectListAndAreaProject(paramsData) {
    return axios.post(
      "/develop/developer/selectListAndAreaProject",
      paramsData
    );
  },
  //开发商绑定项目
  bindProject(paramsData) {
    return axios.post("/develop/developer/bindProject", paramsData);
  },
  //查询开发商集团列表
  devGroupList(paramsData) {
    return axios.post("/develop/developer/group/list", paramsData);
  },
  //查询开发商集团详情
  devGroupDetail(paramsData) {
    return axios.get("/develop/developer/group/detail", { params: paramsData });
  },
  //查询开发商集团详情
  saveDevGroup(paramsData) {
    return axios.post("/develop/developer/group/save", paramsData);
  },
  //关联开发商集团
  associationDevGroup(paramsData) {
    return axios.post("/develop/developer/group/association", paramsData);
  },
  //集团跟进轴
  devGroupFollowRecord(paramsData) {
    return axios.post("/develop/developer/group/followRecord", paramsData);
  },
  //获取通讯录职位筛选
  getRoleLevelList(paramsData) {
    return axios.get("/develop/role/roleLevelList", { params: paramsData });
  },
  //获取通讯录列表
  getAddressBookList(paramsData) {
    return axios.post("/develop/addressBook/list", paramsData);
  },
  //获取通讯录员工项目
  currentStaffProjectList(paramsData) {
    return axios.get("/develop/saleStaff/currentStaffProjectList", {
      params: paramsData
    });
  },
  //获取通讯录员工详情
  getStaffDetail(paramsData) {
    return axios.get("/develop/addressBook/detail", { params: paramsData });
  },
  //已打盘项目
  hisProjectList(paramsData) {
    return axios.post("/develop/saleStaff/hisProjectList", paramsData);
  },
  //获取调拨记录
  getAllocationLog(paramsData) {
    return axios.get(`/develop/saleStaff/getAllocationLog`, {
      params: paramsData
    });
  },
  //预测销量
  createProjectForecast(paramsData) {
    return axios.post(
      "/develop/project/manage/createProjectForecast",
      paramsData
    );
  },
  //获取调拨记录
  projectManagerFile(paramsData) {
    return axios.get(`/develop/project/manage/projectManagerFile`, {
      params: paramsData
    });
  },
  //删除资源
  deleteResource(paramsData) {
    return axios.post("/develop/resource/manage/delete", paramsData);
  },
  //付款待审核列表
  getPaymentCheckList(paramsData) {
    return axios.post(`/develop/contract/paymentCheck/list`, paramsData);
  },
  //付款审核
  getPaymentCheck(paramsData) {
    return axios.post(`/develop/contract/paymentCheck/check`, paramsData);
  },
  //付款审核详情
  getPaymentCheckDeatil(paramsData) {
    return axios.get(`/develop/contract/paymentCheck/detail`, {
      params: paramsData
    });
  },
  //保证金列表
  getPendingList(paramsData) {
    return axios.post(`/develop/contract/pending/list`, paramsData);
  },
  //保证金催收
  getPendingUrge(paramsData) {
    return axios.post(`/develop/contract/pending/urge`, paramsData);
  },
  //保证金处理详情
  getPendingDetail(paramsData) {
    return axios.get(`/develop/contract/pending/detail`, {
      params: paramsData
    });
  },
  //保证金催收
  paymentMethodChange(paramsData) {
    return axios.post(`/develop/contract/paymentMethodChange`, paramsData);
  },
  //项目详情打分列表
  getDetailtableList(paramsData) {
    return axios.get(`/develop/scoring/tableList`, { params: paramsData });
  },
  //资源跟进轴数据
  getFollowResourceDetail(paramsData) {
    return axios.post(`/develop/resource/follow/resourceDetail`, paramsData);
  },
  //数据表上传
  dataImport(paramsData) {
    return axios.post(`/develop/project/manage/dataImport`, paramsData);
  },
  //获取场次信息
  getHisInfoByProjectId(paramsData) {
    return axios.get(`/develop/project/manage/getHisInfoByProjectId`, {
      params: paramsData
    });
  },
  //项目详情(因项目经理业绩优秀而合作的项目,经理)-获取场次信息
  getProjectInfoByManagerId(paramsData) {
    return axios.get(`/develop/project/manage/getProjectInfoByManagerId`, {
      params: paramsData
    });
  },
  //获取所有场次信息
  selectHistime(paramsData) {
    return axios.get(`/develop/project/manage/selectHistime`, {
      params: paramsData
    });
  },
  //资源标签
  getTag(paramsData) {
    return axios.get(`/develop/resource/tag/get`, { params: paramsData });
  },
  //设置标签
  setTag(paramsData) {
    return axios.post(`/develop/resource/tag/set`, paramsData);
  },
  //待处理数据确认列表
  pendingList(paramsData) {
    return axios.post(`/develop/project/outerChain/pendingList`, paramsData);
  },
  //创建外链
  createOuterChain(paramsData) {
    return axios.post(`/develop/project/outerChain/create`, paramsData);
  },
  //数据表 根据类型调取信息
  getTypeInfo(paramsData) {
    return axios.get(`/develop/project/outerChain/info`, {
      params: paramsData
    });
  },
  //数据表 外链保存
  saveOuterChainInfo(paramsData) {
    return axios.post(
      `/develop/project/outerChain/save?key=` + paramsData.key,
      paramsData.list
    );
  },
  //外链确认
  confirmOuterChain(paramsData) {
    return axios.post("/develop/project/outerChain/confirm", paramsData);
  },
  //获取最后一次外链
  getLastKey(paramsData) {
    return axios.post("/develop/project/outerChain/lastKey", paramsData);
  },
  //上传本地录音
  uploadLocalRecord(paramsData) {
    return axios.post(base.phoneUrl + `/call/uploadLocalCall`, paramsData);
  },
  //获取发票报销类型
  reimbursementTypeList(paramsData) {
    return axios.get("/develop/reimbursement/typeList", { params: paramsData });
  },
  //报销项目列表
  reimbursementProjectList(paramsData) {
    return axios.post("/develop/reimbursement/projectList", paramsData);
  },
  //获取费用归属公司
  getCollectionAccount(paramsData) {
    return axios.get("/develop/collectionAccount/list", { params: paramsData });
  },
  //日常报销提交
  reimbursementSave(paramsData) {
    return axios.post("/develop/reimbursement/save", paramsData);
  },
  //日常报销作废
  reimbursementCancel(paramsData) {
    return axios.post("/develop/reimbursement/cancel", paramsData);
  },
  //付款申请作废
  paymentApplicationCancel(paramsData) {
    return axios.post("/develop/paymentApplication/cancel", paramsData);
  },
  //获取外部收款账户列表
  getExternalCollectionAccountList(paramsData) {
    return axios.get("/develop/externalCollectionAccount/list", {
      params: paramsData
    });
  },
  //删除外部收款账户
  delExternalCollectionAccount(paramsData) {
    return axios.post("/develop/externalCollectionAccount/del", paramsData);
  },
  //编辑外部收款账户
  editExternalCollectionAccount(paramsData) {
    return axios.post("/develop/externalCollectionAccount/edit", paramsData);
  },
  //获取付款类型
  getPaymentApplicationType(paramsData) {
    return axios.get("/develop/paymentApplication/paymentType", {
      params: paramsData
    });
  },
  //日常报销列表
  reimbursementList(paramsData) {
    return axios.post("/develop/reimbursement/list", paramsData);
  },
  //付款申请获取项目场次
  getSelectProjectHis(paramsData) {
    return axios.get("/develop/paymentApplication/selectProjectHis", {
      params: paramsData
    });
  },
  //提交付款申请
  savePaymentApplication(paramsData) {
    return axios.post("/develop/paymentApplication/save", paramsData);
  },
  //审核付款申请-出纳相关数据保存
  saveUpdatePaymentApplication(paramsData) {
    return axios.post("/develop/paymentApplication/update", paramsData);
  },
  //审核付款申请上传发票
  uploadInvoicePaymentApplication(paramsData) {
    return axios.post("/develop/paymentApplication/uploadInvoice", paramsData);
  },
  //付款申请详情
  getPaymentApplicationDetail(paramsData) {
    return axios.get("/develop/paymentApplication/detail", {
      params: paramsData
    });
  },
  //付款流程撤回
  paymentApplicationWithdrawn(paramsData) {
    return axios.post("/develop/act/paymentApplication/withdrawn", paramsData);
  },
  //付款流程审核
  paymentApplicationCompleteAudit(paramsData) {
    return axios.post("/develop/act/paymentApplication/complete", paramsData);
  },
  //OA待处理列表
  getOAPendingList(paramsData) {
    return axios.post("/develop/act/pendingList", paramsData);
  },
  //获取日常报销详情
  getrReimbursementDetail(paramsData) {
    return axios.get("/develop/reimbursement/detail", { params: paramsData });
  },
  //获取ai日常报销详情
  getrReimbursementDetailAi(paramsData) {
    return axios.get("/develop/reimbursement/aiAnalyzesInvoiceInformation", { params: paramsData });
  },
  //获取流程信息
  getCheckInfo(paramsData) {
    return axios.get("/develop/act/checkInfo", { params: paramsData });
  },
  //获取合同商务条款流程信息
  contractManageCheckInfo(paramsData) {
    return axios.get("/develop/contractManageCheck/contractManageCheckInfo", {
      params: paramsData
    });
  },
  //合同商务条款审核
  contractManageSureCheck(paramsData) {
    return axios.post(
      "/develop/contractManageCheck/contractManageSureCheck",
      paramsData
    );
  },
  //日常报销撤回
  dailyPayWithdrawn(paramsData) {
    return axios.post(
      "/develop/act/reimbursement/withdrawn?billId=" + paramsData.billId,
      paramsData
    );
  },
  //日常报审核
  dailyPayCompleteAudit(paramsData) {
    return axios.post("/develop/act/reimbursement/complete", paramsData);
  },
  //我发起的待付款列表
  paymentApplicationList(paramsData) {
    return axios.post("/develop/paymentApplication/list", paramsData);
  },
  //oa待处理统计
  pendingSelect(paramsData) {
    return axios.get("/develop/reimbursement/pendingSelect", {
      params: paramsData
    });
  },
  //发票数量查询
  invoiceSelect(paramsData) {
    return axios.get("/develop/reimbursement/invoiceSelect", {
      params: paramsData
    });
  },
  //OA我发起的
  mySendList(paramsData) {
    return axios.post("/develop/act/mySendList", paramsData);
  },
  //OA我收到的
  hisList(paramsData) {
    return axios.post("/develop/act/hisList", paramsData);
  },
  //获取开发商/物业列表
  selectDeveloperAndPropertyList(paramsData) {
    return axios.get(`/develop/resource/manage/selectDeveloperAndProperty`, {
      params: paramsData
    });
  },
  //获取合同付款列表
  getContractManagePayment(paramsData) {
    return axios.get(`/develop/contract/contractManagePayment`, {
      params: paramsData
    });
  },
  //获取百度token
  getBaiduToken(paramsData) {
    return axios.get("/develop/idCard", { params: paramsData });
  },
  //批量送礼
  batchSendGift(paramsData) {
    return axios.post("/develop/resource/gift/batchSendGift", paramsData);
  },
  //获取已标记送礼
  selectBatchResource(paramsData) {
    return axios.get(`/develop/resource/gift/selectBatchResource`, {
      params: paramsData
    });
  },
  //抄送我的
  ccList(paramsData) {
    return axios.post("/develop/act/ccList", paramsData);
  },
  //30天送礼查询
  selectThirtyGift(paramsData) {
    return axios.get(`/develop/resource/gift/selectThirtyGift`, {
      params: paramsData
    });
  },
  //居间协议列表
  agreementList(paramsData) {
    return axios.post("/develop/agreement/agreementList", paramsData);
  },
  //居间协新增
  agreementAdd(paramsData) {
    return axios.post("/develop/agreement/agreementAdd", paramsData);
  },
  //添加同行
  sameIndustrySave(paramsData) {
    return axios.post("/develop/sameIndustry/save", paramsData);
  },
  //获取同行列表
  sameIndustryGet(paramsData) {
    return axios.get(`/develop/sameIndustry/get`, { params: paramsData });
  },
  //添加同行销售情况
  saveSameIndustrySale(paramsData) {
    return axios.post("/develop/sameIndustry/saveSameIndustrySale", paramsData);
  },
  //查询同行销售情况列表
  getSameIndustrySale(paramsData) {
    return axios.get(`/develop/sameIndustry/getSameIndustrySale`, {
      params: paramsData
    });
  },
  //获取同行详情（项目信息详情）
  projectSameIndustrySale(paramsData) {
    return axios.get(`/develop/sameIndustry/projectSameIndustrySale`, {
      params: paramsData
    });
  },
  //获取催收信息(场次id)
  selectPressMoneyInfoByHisId(paramsData) {
    return axios.get("/develop/pressMoney/selectPressMoneyInfoByHisId", {
      params: paramsData
    });
  },
  //催收新增/结束
  pressMoneySave(paramsData) {
    return axios.post("/develop/pressMoney/save", paramsData);
  },
  //催收列表
  pressMoneyList(paramsData) {
    return axios.post("/develop/pressMoney/pressMoneyList", paramsData);
  },
  //获取催收信息(催收id)
  selectPressMoneyInfoByPressId(paramsData) {
    return axios.get("/develop/pressMoney/selectPressMoneyInfoByPressId", {
      params: paramsData
    });
  },
  //获取催收信息时间轴
  selectFollowTimeByPressId(paramsData) {
    return axios.get("/develop/pressMoney/selectFollowTimeByPressId", {
      params: paramsData
    });
  },
  //获催收详情
  selectFollowDetailByPressId(paramsData) {
    return axios.get("/develop/pressMoney/selectFollowDetailByPressId", {
      params: paramsData
    });
  },
  //获商务条款详情
  selectContractDetail(paramsData) {
    return axios.get("/develop/pressMoney/selectContractDetail", {
      params: paramsData
    });
  },
  //统计-获取项目信息
  statisticsProjectData(paramsData) {
    return axios.post(`/develop/project/manage/selectProjectData`, paramsData);
  },
  //获取催收项目列表
  getPressMoneyProjectList(paramsData) {
    return axios.post(`/develop/pressMoney/getProjectList`, paramsData);
  },
  //获取催收信息(合同id)
  purchaseDetail(paramsData) {
    return axios.get("/develop/purchase/detail", { params: paramsData });
  },
  //采购获取地址
  purchaseAddress(paramsData) {
    return axios.get(`/develop/purchase/purchaseAddress`, {
      params: paramsData
    });
  },
  //获取借用记录
  getBorrowList(paramsData) {
    return axios.get("/develop/borrow/borrowList", { params: paramsData });
  },
  //设置借用状态
  setBorrowSetStatus(paramsData) {
    return axios.post(`/develop/borrow/borrowSetStatus`, paramsData);
  },
  //获取合同列表列表
  getContractManage(paramsData) {
    return axios.post(`/develop/pressMoney/getContractManage`, paramsData);
  },
  //设置借用状态
  setBorrowCheck(paramsData) {
    return axios.post(`/develop/borrow/borrowCheck`, paramsData);
  },
  //获取催收信息(合同id)
  selectPressMoneyInfoByContractId(paramsData) {
    return axios.get("/develop/pressMoney/selectPressMoneyInfoByContractId", {
      params: paramsData
    });
  },
  //是否在时间内打卡
  isSlotClock(paramsData) {
    return axios.get("/develop/clockOn/isSlotClock", { params: paramsData });
  },
  //预打款列表
  advancePaymentList(paramsData) {
    return axios.get("/develop/advancePayment/advancePaymentList", {
      params: paramsData
    });
  },
  //预打款详情
  advancePaymentDetail(paramsData) {
    return axios.get("/develop/advancePayment/detail", { params: paramsData });
  },
  //预打款保存
  advancePaymentSave(paramsData) {
    return axios.post(`/develop/advancePayment/save`, paramsData);
  },
  //项目信息历史备份场次id
  projectBackupHisInfo(paramsData) {
    return axios.get("/develop/project/manage/projectBackupHisInfo", {
      params: paramsData
    });
  },
  //获取合同列表列表
  sameIndustryDel(paramsData) {
    return axios.get(`/develop/sameIndustry/del`, { params: paramsData });
  },
  //市场专员添加项目
  createProjectByMarkPerson(paramsData) {
    return axios.post(`/develop/specialist/createProject`, paramsData);
  },
  //条件查询市场专员项目列表
  projectListForMarkPerson(paramsData) {
    return axios.post(`/develop/specialist/projectList`, paramsData);
  },
  //获取市场专员项目详情
  projectDetailForMarkPerson(paramsData) {
    return axios.get(`/develop/specialist/projectDetail`, {
      params: paramsData
    });
  },
  //市场专员提交项目审核
  projectCheckedSubmit(paramsData) {
    return axios.post(`/develop/specialist/checked`, paramsData);
  },
  //查询市场专员统计
  statisticsForMarkPerson(paramsData) {
    return axios.get(`/develop/specialist/statistics`, { params: paramsData });
  },
  //借出物品类型
  getGoodsBorrowType(paramsData) {
    return axios.get(`/develop/borrow/getType`, { params: paramsData });
  },
  //获取打盘结束待复盘信息-工作台
  saleFinishedWaitReplayInfo(paramsData) {
    return axios.get(`/develop/sameIndustry/saleFinishedWaitReplayInfo`, {
      params: paramsData
    });
  },
  //合同借出
  contractBorrowApply(paramsData) {
    return axios.post(`/develop/borrow/contractBorrowApply`, paramsData);
  },
  //物品借出
  goodsBorrowApply(paramsData) {
    return axios.post(`/develop/borrow/goodsBorrowApply`, paramsData);
  },
  //合同借出审核
  contractBorrowCheck(paramsData) {
    return axios.post(`/develop/borrow/contractBorrowCheck`, paramsData);
  },
  //获取签约项目及其关联合同
  signProject(paramsData) {
    return axios.get(`/develop/borrow/signProject`, { params: paramsData });
  },
  //pk列表
  pkProjectList(paramsData) {
    return axios.post(`/develop/pk/list`, paramsData);
  },
  //支付
  commonPay(paramsData) {
    return axios.post(`/develop/pay/pay`, paramsData);
  },
  //我的PK
  myPKInfo(paramsData) {
    return axios.post(`/develop/pk/myPk`, paramsData);
  },
  //获取合同保证金催收弹窗
  // getPressMoneyAlert(paramsData) {
  //     return axios.post(`/develop/pressMoney/getPressMoneyAlert`, paramsData);
  // },
  getPressMoneyAlert(paramsData) {
    return axios.post(`/develop/pressMoney/pressMoneyAlert`, paramsData);
  },
  //合同列表
  getContractList(paramsData) {
    return axios.post(`/develop/contract/list`, paramsData);
  },
  //合同详情
  getContractDetail(paramsData) {
    return axios.get(`/develop/contract/detail`, { params: paramsData });
  },
  // 获取合同详情列表数据
  getProjectListDetailData(paramsData) {
    return axios.get(`/develop/contract/manage/detail`, { params: paramsData });
  },
  //打分评价列表
  evaluateList(paramsData) {
    return axios.get(`/develop/scoring/evaluateList`, { params: paramsData });
  },
  //复盘表
  projectReplay(paramsData) {
    return axios.post(`/develop/expandReplay/replay`, paramsData);
  },
  //复盘列表
  expandReplayList(paramsData) {
    return axios.post(`/develop/expandReplay/list`, paramsData);
  },
  //待复盘 转交
  transferExpandReplay(paramsData) {
    return axios.post(`/develop/expandReplay/transfer`, paramsData);
  },
  //待复盘 选择复盘项目
  selectReplayProject(paramsData) {
    return axios.post(`/develop/expandReplay/selectReplayProject`, paramsData);
  },
  //待复盘 选择复盘合同
  selectReplayContract(paramsData) {
    return axios.post(`/develop/expandReplay/selectReplayContract`, paramsData);
  },
  //待复盘 新增复盘
  addExpandReplay(paramsData) {
    return axios.post(`/develop/expandReplay/add`, paramsData);
  },
  //打分评价列表
  replayDetail(paramsData) {
    return axios.get(`/develop/expandReplay/detail`, { params: paramsData });
  },
  //抵押文件列表
  contractMortgageList(paramsData) {
    return axios.get(`/develop/ContractMortgage/list`, { params: paramsData });
  },
  //抵押文件-解押
  dischargeMortgage(paramsData) {
    return axios.post(
      `/develop/ContractMortgage/dischargeMortgage`,
      paramsData
    );
  },
  //抵押文件-抵押记录
  contractMortgageLog(paramsData) {
    return axios.get(`/develop/ContractMortgage/contractMortgageLog`, {
      params: paramsData
    });
  },
  //抵押文件-解押记录
  contractDischargeMortgageLog(paramsData) {
    return axios.get(`/develop/ContractMortgage/contractDischargeMortgageLog`, {
      params: paramsData
    });
  },
  //登记文件
  contractMortgageFileList(paramsData) {
    return axios.get(`/develop/ContractMortgage/fileList`, {
      params: paramsData
    });
  },
  //公告收藏
  announcementCollect(paramsData) {
    return axios.post(`/develop/announcement/collect`, paramsData);
  },
  //项目详情-因业绩好签约的销售经理 选择列表
  selectHisInfoList(paramsData) {
    return axios.post(`/develop/project/manage/selectHisInfoList`, paramsData);
  },
  //项目相关文件
  projectFileList(paramsData) {
    return axios.get(`/develop/project/manage/projectFileList`, {
      params: paramsData
    });
  },
  //查询历史项目详情
  projectHistory(paramsData) {
    return axios.get(`/develop/project/manage/projectHistory`, {
      params: paramsData
    });
  },
  //待办事项 列表
  getToDoList(paramsData) {
    return axios.get(`/develop/pending/toDoList/get`, { params: paramsData });
  },
  //待办事项-提交铺排跟进
  addFollowToDoList(paramsData) {
    return axios.post(`/develop/pending/toDoList/addFollow`, paramsData);
  },
  //待办事项-提交首次打盘建议跟进
  addFirstSalePropose(paramsData) {
    return axios.post(
      `/develop/pending/toDoList/addFirstSalePropose`,
      paramsData
    );
  },
  //待办事项-提交跟进
  addToDoList(paramsData) {
    return axios.post(`/develop/pending/toDoList/addToDoList`, paramsData);
  },
  //待办事项 铺排跟进时间轴
  getToDoFollowList(paramsData) {
    return axios.get(`/develop/pending/toDoList/followList`, {
      params: paramsData
    });
  },
  //待办事项 铺排跟进时间轴
  getFirstSaleProposeDetailList(paramsData) {
    return axios.get(`/develop/pending/toDoList/firstSaleProposeDetailList`, {
      params: paramsData
    });
  },
  //待办事项 跟进时间轴
  getToDoListDetail(paramsData) {
    return axios.get(`/develop/pending/toDoList/getToDoListDetail`, {
      params: paramsData
    });
  },
  //人员积分
  getStaffIntegral(paramsData) {
    return axios.get(`/develop/staffIntegral/get`, { params: paramsData });
  },
  //违纪
  getStaffViolation(paramsData) {
    return axios.get(`/develop/staffViolation/get`, { params: paramsData });
  },
  //获取员工个人积分
  staffPersonalIntegral(paramsData) {
    return axios.get(`/develop/staffIntegral/staffPersonalIntegral`, {
      params: paramsData
    });
  },
  //库存车位/过户时间已到期
  contractTimeAlert(paramsData) {
    return axios.get(`/develop/contract/timeAlert`, { params: paramsData });
  },
  //项目踩盘列表
  firstInfoList(paramsData) {
    return axios.post(`/develop/project/firstInfo/list`, paramsData);
  },
  //项目踩盘详情
  firstInfoDetail(paramsData) {
    return axios.get(`/develop/project/firstInfo/detail`, {
      params: paramsData
    });
  },
  //保存项目踩盘
  consultCollectInfo(paramsData) {
    return axios.post(`/develop/project/firstInfo/consult`, paramsData);
  },
  //项目踩盘转交
  transfer(paramsData) {
    return axios.post(`/develop/project/firstInfo/transfer`, paramsData);
  },
  //合同商务条款
  contractManageCheck(paramsData) {
    return axios.get(
      `/develop/contractManageCheck/develop/contractManageCheck`,
      { params: paramsData }
    );
  },
  //合同商务条款详情
  contractManageCommercialTerms(paramsData) {
    return axios.get(
      `/develop/contractManageCheck/contractManageCommercialTerms`,
      { params: paramsData }
    );
  },
  //项目项目推演详情
  warGameDetail(paramsData) {
    return axios.get(`/develop/project/warGame/detail`, { params: paramsData });
  },
  //项目项目推演
  saveGame(paramsData) {
    return axios.post(`/develop/project/warGame/save`, paramsData);
  },
  //项目推演列表
  warGameList(paramsData) {
    return axios.post(`/develop/project/warGame/list`, paramsData);
  },
  //项目推演邀请
  warGameInvitation(paramsData) {
    return axios.post(`/develop/project/warGame/invitation`, paramsData);
  },
  //获取action
  getActions(paramsData) {
    return axios.get(`/develop/actions`, { params: paramsData });
  },
  //获取合同相关项目
  getContractToDoListDetail(paramsData) {
    return axios.get(`/develop/pending/toDoList/contractToDoListDetail`, {
      params: paramsData
    });
  },
  //待办合同跟进
  contractToDoListProjectFollow(paramsData) {
    return axios.post(
      `/develop/pending/toDoList/contractToDoListProjectFollow`,
      paramsData
    );
  },
  //获取签约流程信息
  getProjectProcess(paramsData) {
    return axios.get(`/develop/project/process/getProjectProcess`, {
      params: paramsData
    });
  },
  //保存签约流程信息
  saveProjectProcess(paramsData) {
    return axios.post(
      `/develop/project/process/saveProjectProcess`,
      paramsData
    );
  },
  //获取签约流程信息历史
  getProjectHistoryProcess(paramsData) {
    return axios.get(`/develop/project/process/getProjectHistoryProcess`, {
      params: paramsData
    });
  },
  //开启续签
  startNewProcess(paramsData) {
    return axios.post(`/develop/project/process/startNewProcess`, paramsData);
  },
  //获取开发商详情
  getDeveloperDetail(paramsData) {
    return axios.get(`/develop/developer/detail`, { params: paramsData });
  },
  //问卷调查-项目列表
  questionProjectList(paramsData) {
    return axios.post(`/develop/question/projectList`, paramsData);
  },
  //问卷调查-业主修改
  questionCustomerUpdate(paramsData) {
    return axios.post(`/develop/question/customerUpdate`, paramsData);
  },
  //问卷调查-业主集合
  questionCustomerList(paramsData) {
    return axios.post(`/develop/question/customerList`, paramsData);
  },
  //问卷调查-业主详情
  questionCustomerDetail(paramsData) {
    return axios.get(`/develop/question/customerDetail`, {
      params: paramsData
    });
  },
  //问卷调查-业主详情-通话记录
  questionCall(paramsData) {
    return axios.get(`/develop/question/call`, { params: paramsData });
  },
  //问卷调查-业主ids
  questionSelectCustomerId(paramsData) {
    return axios.post(`/develop/question/selectCustomerId`, paramsData);
  },
  //问卷调查-销售
  questionAllSale(paramsData) {
    return axios.get(`/develop/question/allSale`, { params: paramsData });
  },
  //问卷调查报告
  questionSaveRemark(paramsData) {
    return axios.post(`/develop/question/saveRemark`, paramsData);
  },
  //问卷调查-业主详情-通话记录
  questionCall(paramsData) {
    return axios.get(`/develop/question/call`, { params: paramsData });
  },
  //获取通话记录
  getCallList(paramsData) {
    return axios.get(`/develop/customer/call`, { params: paramsData });
  },
  //项目推演前提保存
  savePre(paramsData) {
    return axios.post(`/develop/project/warGame/savePre`, paramsData);
  },
  //项目推演前提详情
  preDetail(paramsData) {
    return axios.get(`/develop/project/warGame/preDetail`, {
      params: paramsData
    });
  },
  //是否交pk金
  pkOver(paramsData) {
    return axios.get(`/develop/project/warGame/pkOver`, { params: paramsData });
  },
  //获取拓展人员的礼品列表个人库存
  getGiftListForPersonal(paramsData) {
    return axios.get(`/develop/reserve/giftList`, { params: paramsData });
  },
  //库存信息转移个人库存
  reserveOutForPersonal(paramsData) {
    return axios.post(`/develop/reserve/reserveOut`, paramsData);
  },
  //个人库存记录
  reserveLogListForPersonal(paramsData) {
    return axios.get("/develop/reserve/reserveLog", { params: paramsData });
  },
  //个人库存遗失报备
  lostGiftForPersonal(paramsData) {
    return axios.post(`/develop/reserve/lost`, paramsData);
  },
  //获取待接收列表个人库
  acceptedReserveForPersonal(paramsData) {
    return axios.get(`/develop/reserve/acceptedReserve`, {
      params: paramsData
    });
  },
  //个人库存接收个人库
  addReceiveForPersonal(paramsData) {
    return axios.post(`/develop/reserve/receive`, paramsData);
  },
  //上传开发商
  developersUploadFile(paramsData) {
    return axios.post("/develop/developer/uploadFile", paramsData);
  },
  //开发商文件列表
  developerFileList(paramsData) {
    return axios.get(`/develop/developer/fileList`, { params: paramsData });
  },
  //提交打分表草稿
  postScoreUpdate(paramsData) {
    return axios.post("/develop/scoring/web/update", paramsData);
  },
  //图片转base64
  base64Fomat(paramsData) {
    return axios.get(`https://api.mfzcw.com/upload/upload/PDFChangeBase64`, {
      params: paramsData
    });
  },
  //获取是否人脸识别标记
  getIsFaceClockIn(paramsData) {
    return axios.get(`/develop/faceClockOn`, { params: paramsData });
  },
  //经理 录音 （已听记录）
  addSoundPlayRecord(paramsData) {
    return axios.post(`/develop/soundPlayRecord/add`, paramsData);
  },
  //获取通用弹框
  getSystemAlert(paramsData) {
    return axios.get(`/develop/project/manage/signOutTimeAlert`, {
      params: paramsData
    });
  },
  //获取免登录
  getFreeLoginUrl(paramsData) {
    return axios.get("/develop/xrxs/getFreeLoginUrl", { params: paramsData });
  },
  //获取审批数量
  getApprovalNum(paramsData) {
    return axios.get("/develop/xrxs/getApprovalNum", { params: paramsData });
  },
  //获取项目评估详情
  getProjectReviewDetail(paramsData) {
    return axios.get("/develop/project/review/detail", { params: paramsData });
  },
  //获取项目评估详情保存
  projectReviewSave(paramsData) {
    return axios.post("/develop/project/review/save", paramsData);
  },
  //鱼骨保存
  fishboneSave(paramsData) {
    return axios.post("/develop/project/fishbone/save", paramsData);
  },
  //鱼骨列表
  fishbonePageList(paramsData) {
    return axios.post("/develop/project/fishbone/fishbonePage", paramsData);
  },
  //预测销量添加场次
  saveForecast(paramsData) {
    return axios.post("/develop/project/fishbone/saveForecast", paramsData);
  },
  //预测销量场次列表
  forecastList(paramsData) {
    return axios.get("/develop/project/fishbone/forecastList", {
      params: paramsData
    });
  },
  //新增结算信息
  saveOrUpdateSettlementList(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/saveOrUpdateSettlementList",
      paramsData
    );
  },
  //新增结算详情
  listDetail(paramsData) {
    return axios.get(base.settlementUrl + "/settlement/settlement/listDetail", {
      params: paramsData
    });
  },
  //月度结算列表
  getMonthSettlementList(paramsData) {
    return axios.get(
      base.settlementUrl + "/settlement/settlement/monthSettlementList",
      { params: paramsData }
    );
  },
  //设置不结算
  setNoSettlement(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/setNoSettlement",
      paramsData
    );
  },
  //删除开发商详情
  deletDeveloperDetail(paramsData) {
    return axios.post(`/develop/developer/del`, paramsData);
  },
  //查询日志列表（buyHisId）
  projectHisDailyLogList(paramsData) {
    return axios.get(`/develop/expandReplay/projectHisDailyLogList`, {
      params: paramsData
    });
  },
  //查询月度复盘数据
  queryReview(paramsData) {
    return axios.get(`/develop/monthlyReplay/get`, { params: paramsData });
  },
  //银行账户余额查询
  queryBankAccountBalance(paramsData) {
    return axios.get(
      base.settlementUrl + `/settlement/bankAccountBalance/get`,
      { params: paramsData }
    );
  },
  //价值地图获取地区
  getProjectMapArea(paramsData) {
    return axios.get(`/develop/projectMap/get`, { params: paramsData });
  },
  //价值地图获取项目
  getProjectMapProject(paramsData) {
    return axios.get(`/develop/projectMap/getProject`, { params: paramsData });
  },
  //获取补充开发商列表
  querySuppleDeveloperList(paramsData) {
    return axios.post(`/develop/developer/improve/list`, paramsData);
  },
  //获取补充跟进记录
  getDevelopFollowRecord(paramsData) {
    return axios.get(`/develop/developer/improve/followRecord`, {
      params: paramsData
    });
  },
  //保存新建补充开发商
  saveSuppleDeveloper(paramsData) {
    return axios.post(`/develop/developer/improve/save`, paramsData);
  },
  //获取开发商详情
  querySuppleDeveloperDetail(paramsData) {
    return axios.get(`/develop/developer/improve/detail`, {
      params: paramsData
    });
  },
  //校验开发商是否被其它占用
  validateDeveloperData(paramsData) {
    return axios.get(`/develop/developer/improve/findByDeveloperId`, {
      params: paramsData
    });
  },
  //确认验证补充开发商
  confirmDeveloperInfo(paramsData) {
    return axios.post(`/develop/developer/improve/confirmVerify`, paramsData);
  },
  // //上传朋友圈素材
  // uploadFriendCircle(paramsData) {
  //     return axios.post(`/develop/friendsCircle/upload`, paramsData);
  // },
  // //删除盆友圈素材
  // deleteFriendCircleMaterial(paramsData) {
  //     return axios.post(`/develop/friendsCircle/del`, paramsData);
  // },
  // //我的素材上传记录
  // uploadFriendCircleHistory(paramsData) {
  //     return axios.get(`/develop/friendsCircle/uploadHistory`, { params: paramsData });
  // },
  //获取其他人的swot选项
  selectFishboneInfoByForecastId(paramsData) {
    return axios.get(
      `/develop/project/fishbone/selectFishboneInfoByForecastId`,
      { params: paramsData }
    );
  },
  //预测销量获取详情
  selectFishboneByForecastId(paramsData) {
    return axios.get(`/develop/project/fishbone/selectFishboneByForecastId`, {
      params: paramsData
    });
  },
  //删除预测销量
  fishboneDelete(paramsData) {
    return axios.post(`/develop/project/fishbone/delete`, paramsData);
  },
  //协助查看价格申请
  assistLookPriceAdd(paramsData) {
    return axios.post(
      `/develop/project/manage/assistLookPrice/add`,
      paramsData
    );
  },
  //协助查看价格申请列表
  assistLookPriceList(paramsData) {
    return axios.get(`/develop/project/manage/assistLookPrice/list`, {
      params: paramsData
    });
    //  return axios.post(`/develop/project/manage/assistLookPrice/list`, {params: paramsData})
  },
  //协助查看价格申请详情
  assistLookPriceDetail(paramsData) {
    return axios.get(`/develop/project/manage/assistLookPrice/detail`, {
      params: paramsData
    });
  },
  //协助查看价格申请确认
  assistLookPriceConfirm(paramsData) {
    return axios.post(
      `/develop/project/manage/assistLookPrice/confirm`,
      paramsData
    );
  },
  //获取项目流程模板
  getSaleProcessContent(paramsData) {
    return axios.get(`/develop/project/signProcess/getProcess`, {
      params: paramsData
    });
  },
  //项目签约流程保存
  saveSaleProcess(paramsData) {
    return axios.post(`/develop/project/signProcess/saveProcess`, paramsData);
  },
  //获取项目签约流程详情
  getSaleProcessDetail(paramsData) {
    return axios.get(`/develop/project/signProcess/detail`, {
      params: paramsData
    });
  },
  //获取遗失/报损流程
  getLostOrReportedLoss(paramsData) {
    return axios.post(`/develop/reserve/lostProgress/list`, paramsData);
  },
  //遗失报损详情
  getLostProgressDetails(paramsData) {
    return axios.get(`/develop/reserve/lostProgress/detail`, {
      params: paramsData
    });
  },
  //审核遗失/报损
  checkLostApply(paramsData) {
    return axios.post(`/develop/reserve/lostProgress/check`, paramsData);
  },
  //oa 遗失报损数量
  pendingLostNum(paramsData) {
    return axios.get(`/develop/reserve/lostProgress/pendingCount`, {
      params: paramsData
    });
  },
  //获取补充物业列表
  querySupplePropertyList(paramsData) {
    return axios.post(`/develop/property/improve/list`, paramsData);
  },
  //校验开物业商是否被其它占用
  validatePropertyData(paramsData) {
    return axios.get(`/develop/property/improve/findByPropertyId`, {
      params: paramsData
    });
  },
  //保存新建补充物业
  saveSuppleProperty(paramsData) {
    return axios.post(`/develop/property/improve/save`, paramsData);
  },
  //获取物业详情
  querySupplepropertyDetail(paramsData) {
    return axios.get(`/develop/property/improve/detail`, {
      params: paramsData
    });
  },
  //确认验证补充物业
  confirmPropertyInfo(paramsData) {
    return axios.post(`/develop/property/improve/confirmVerify`, paramsData);
  },
  //商品领用列表
  getProductReserveList(paramsData) {
    return axios.post(`/develop/productReserve/list`, paramsData);
  },
  //商品领用保存
  productReserveSave(paramsData) {
    return axios.post(`/develop/productReserve/save`, paramsData);
  },
  //商品领用详情
  productReserveDetail(paramsData) {
    return axios.get(`/develop/productReserve/detail`, { params: paramsData });
  },
  //库存列表信息
  getReserve(paramsData) {
    return axios.post(`/develop/purchase/getReserve`, paramsData);
  },
  //OA模块待办数量
  pendingOaNum(paramsData) {
    return axios.get(`/develop/pending/project/pendingOaNum`, {
      params: paramsData
    });
  },
  //获取大区数据
  queryZoneData(paramsData) {
    return axios.get(`/develop/zone/list`, { params: paramsData });
  },
  //获取渠道佣金列表
  queryCustomerServiceFee(paramsData) {
    return axios.post(`/develop/serviceFee/serviceFeeList`, paramsData);
  },
  //添加甲方复盘会议
  addReviewMeeting(paramsData) {
    return axios.post(
      `/develop/pending/toDoList/createPartyAReviewMeeting`,
      paramsData
    );
  },
  //商学院待处理数据统计
  getSchoolTodo(paramsData) {
    return axios.get(`/develop/school/pendingStatistical`, {
      params: paramsData
    });
  },
  //获取商学院-线下课堂列表
  getOfflinePage(paramsData) {
    return axios.post("/develop/offline/offlinePage", paramsData);
  },
  //获取商学院-讲师列表
  getBusinessSchoolLecturer(paramsData) {
    return axios.get("/develop/businessSchoolLecturer/get", {
      params: paramsData
    });
  },
  //每日一练，每周一练，每周一通列表
  getStaffQuestionPageList(paramsData) {
    return axios.post(`/develop/staffQuestion/questionPage`, paramsData);
  },
  //获取每日一练试卷
  getStaffQuestionDetail(paramsData) {
    return axios.get("/develop/staffQuestion/detail", { params: paramsData });
  },
  //获取商学院列表
  getbusinessCollegeList(paramsData) {
    return axios.post("/develop/school/list", paramsData);
  },
  //获取商学院类别
  getBusinessCollegeType(paramsData) {
    return axios.get("/develop/school/getType", { params: paramsData });
  },
  //获取商学院详情
  getBusinessCollegeDetail(paramsData) {
    return axios.get("/develop/school/getFileDetail", { params: paramsData });
  },
  //获取商学院视频评论
  getBusinessCollegeComment(paramsData) {
    return axios.get("/develop/school/getComment", { params: paramsData });
  },
  //商学院视频新增评论
  AddBusinessCollegeComment(paramsData) {
    return axios.post("/develop/school/addComment", paramsData);
  },
  //商学院视频点赞
  likeBusinessCollegeVideo(paramsData) {
    return axios.post("/develop/school/setLike", paramsData);
  },
  //学院任务
  staffProcessIniTaskList(paramsData) {
    return axios.post(`/develop/staffProcessIni/taskPage`, paramsData);
  },
  //获取商学院-线下课堂详情
  offlineDetail(paramsData) {
    return axios.get("/develop/offline/detail", { params: paramsData });
  },
  //获取商学院-线下课堂保存-上传听课本
  uploadTextBook(paramsData) {
    return axios.post("/develop/offline/uploadTextBook", paramsData);
  },
  //每日一练，每周一练提交
  staffQuestionSave(paramsData) {
    return axios.post(`/develop/staffQuestion/save`, paramsData);
  },
  //物业
  getPropertyFollowRecord(paramsData) {
    return axios.get(`/develop/property/improve/followRecord`, {
      params: paramsData
    });
  },
  //获取定稿合同列表
  getDraftData(paramsData) {
    return axios.post(`/develop/contract/draft/list`, paramsData);
  },
  //保存定稿合同
  saveDraftData(paramsData) {
    return axios.post(`/develop/contract/draft/save`, paramsData);
  },
  //定稿合同详情
  queryDraftContractDetail(paramsData) {
    return axios.get(`/develop/contract/draft/detail`, { params: paramsData });
  },
  //审核记录
  draftApprovalRecord(paramsData) {
    return axios.get(`/develop/contract/draft/checkRecordList`, {
      params: paramsData
    });
  },
  //审核定稿合同
  approvalDraftContract(paramsData) {
    return axios.post(`/develop/contract/draft/check`, paramsData);
  },
  //定稿合同已知悉 /develop/contract/draft/ccRead
  readDraftContract(paramsData) {
    return axios.post(`/develop/contract/draft/ccRead`, paramsData);
  },
  //撤回定稿合同
  withdrawDraftContract(paramsData) {
    return axios.post(`/develop/contract/draft/withdraw`, paramsData);
  },
  //待办事项参会处理
  completeTodo(paramsData) {
    return axios.post(`/develop/pending/toDoList/completeTodo`, paramsData);
  },
  //获取紧急事务
  toDoListGet(paramsData) {
    return axios.get(`/develop/emergent/toDoList/get`, { params: paramsData });
  },
  //完成紧急事务
  completeTodoImportant(paramsData) {
    return axios.post(`/develop/emergent/toDoList/completeTodo`, paramsData);
  },
  //获取项目数据模型
  getProjectDataModel(paramsData) {
    return axios.get(`/develop/projectDataScore/detail`, {
      params: paramsData
    });
  },
  //保存项目数据模型
  saveProjectDataModel(paramsData) {
    return axios.post(`/develop/projectDataScore/save`, paramsData);
  },
  //问卷调查列表
  questionList(paramsData) {
    return axios.get(`/develop/question/questionList`, { params: paramsData });
  },
  //问卷调查详情
  questionDetail(paramsData) {
    return axios.post(`/develop/question/questionListDetail`, paramsData);
  },
  //周边项目列表
  aroundList(paramsData) {
    return axios.post(`/develop/project/manage/aroundList`, paramsData);
  },
  //提交日志点评
  saveDailyLogComment(paramsData) {
    return axios.post(`/develop/my/daily/comment`, paramsData);
  },
  //扫街
  scanStreetList(paramsData) {
    return axios.post(`/develop/project/scanStreet/list`, paramsData);
  },
  //扫街新增项目
  scanStreetAdd(paramsData) {
    return axios.post(`/develop/project/scanStreet/add`, paramsData);
  },
  //获取项目签约等级积分
  queryProjectSignLevelScoreStatistics(paramsData) {
    return axios.post(
      `/develop/project/signLevel/projectSignLevelScoreStatistics`,
      paramsData
    );
  },
  //获取签约等级变更记录
  queryProjectSignLevelRecordList(paramsData) {
    return axios.post(
      `/develop/project/signLevel/projectSignLevelRecordList`,
      paramsData
    );
  },
  //获取预计签约项目
  expectSignList(paramsData) {
    return axios.post(`/develop/project/expectSign/list`, paramsData);
  },
  //获取签约次数
  getSignNum(paramsData) {
    return axios.get(`/develop/project/expectSign/getSignNum`, {
      params: paramsData
    });
  },
  //获取预计签约项目
  expectSignSave(paramsData) {
    return axios.post(`/develop/project/expectSign/save`, paramsData);
  },
  //获取资源交接记录(列表)
  transferList(paramsData) {
    return axios.post(`/develop/resource/transfer/list`, paramsData);
  },
  //发起资源交接
  transferLaunch(paramsData) {
    return axios.post(`/develop/resource/transfer/launch`, paramsData);
  },
  //获取资源交接详情
  transferDetail(paramsData) {
    return axios.get(`/develop/resource/transfer/detail`, {
      params: paramsData
    });
  },
  //删除资源交接详情
  transferDelete(paramsData) {
    return axios.post(`/develop/resource/transfer/delete`, paramsData);
  },
  //资源交接确认
  transferConfirm(paramsData) {
    return axios.post(`/develop/resource/transfer/confirm`, paramsData);
  },
  //获取商务条款列表
  queryBusinessTerms(paramsData) {
    return axios.post(`/develop/commerceClause/list`, paramsData);
  },
  //商务条款详情
  queryBusinessTermsDetail(paramsData) {
    return axios.get(`/develop/commerceClause/detail`, { params: paramsData });
  },
  //保存商务条款
  saveBusinessTerms(paramsData) {
    return axios.post(`/develop/commerceClause/save`, paramsData);
  },
  //获取撤场会议列表
  queryWithdrawalMeeting(paramsData) {
    return axios.post(`/develop/project/withdrawalMeeting/list`, paramsData);
  },
  //商务条款详情
  queryWithdrawalMeetingDetail(paramsData) {
    return axios.get(`/develop/project/withdrawalMeeting/detail`, {
      params: paramsData
    });
  },
  //获取同行列表
  sameIndustryGetV2(paramsData) {
    return axios.post(`/develop/sameIndustry/v2/list`, paramsData);
  },
  //根据项目获取竞争对手
  projectSameIndustryList(paramsData) {
    return axios.get(`/develop/sameIndustry/v2/projectSameIndustryList`, {
      params: paramsData
    });
  },
  //根据竞争对手获取竞争详情
  sameIndustryProjectList(paramsData) {
    return axios.get(`/develop/sameIndustry/v2/sameIndustryProjectList`, {
      params: paramsData
    });
  },
  //项目相关文件V2
  projectFileListV2(paramsData) {
    return axios.get(`/develop/project/manage/projectFileListV2`, {
      params: paramsData
    });
  },
  //上传附件
  uploadRelatedFile(paramsData) {
    return axios.post(`/develop/project/manage/uploadRelatedFile`, paramsData);
  },
  //删除附件
  deleteRelatedFile(paramsData) {
    return axios.post(`/develop/project/manage/deleteRelatedFile`, paramsData);
  },
  //保存积分
  addIntegral(paramsData) {
    return axios.post(`/develop/integralReporting/save`, paramsData);
  },
  //综合积分提报列表
  interalList(paramsData) {
    return axios.get(`/develop/integralReporting/list`, { params: paramsData });
  },
  //综合积分提报审核
  checkInteralData(paramsData) {
    return axios.post(`/develop/integralReporting/check`, paramsData);
  },
  //取消红点
  cancelRedDot(paramsData) {
    return axios.post(`/develop/integralReporting/cancelRed`, paramsData);
  },
  //复盘项目列表
  replayList(paramsData) {
    return axios.post(`/develop/project/inferAndReplay/replayList`, paramsData);
  },
  //获取复盘信息
  inferDetail(paramsData) {
    return axios.get(`/develop/project/inferAndReplay/replayDetail`, {
      params: paramsData
    });
  },
  //获取复盘信息
  projectHisInfo(paramsData) {
    return axios.get(`/develop/project/inferAndReplay/projectHisInfo`, {
      params: paramsData
    });
  },
  //获取推盘信息
  replayDetailTP(paramsData) {
    return axios.get(`/develop/project/inferAndReplay/inferDetail`, {
      params: paramsData
    });
  },
  //删除商务条款
  deleteCommerceClause(paramsData) {
    return axios.post(`/develop/commerceClause/delete`, paramsData);
  },
  //删除项目跟进
  deleteProjectFollow(paramsData) {
    return axios.post(`/develop/pending/project/followDel`, paramsData);
  },
  //保证金收据列表
  paymentApplicationReceiptList(paramsData) {
    return axios.post(
      `/develop/contract/paymentApplicationReceiptList`,
      paramsData
    );
  },
  //保证金收据修改
  setPaymentApplicationReceiptInfo(paramsData) {
    return axios.post(
      `/develop/contract/setPaymentApplicationReceiptInfo`,
      paramsData
    );
  },
  //用章申请
  useSealApply(paramsData) {
    return axios.post(`/develop/borrow/useSealApply`, paramsData);
  },
  //用章申请详情
  useSealApplyDetail(paramsData) {
    return axios.get(`/develop/borrow/useSealApplyDetail`, {
      params: paramsData
    });
  },
  //用章申请审核
  useSealApplyCheck(paramsData) {
    return axios.post(`/develop/borrow/useSealApplyCheck`, paramsData);
  },
  //获取项目关联预打款数据
  advancePaymentInfo(paramsData) {
    return axios.get(`/develop/paymentApplication/cancel`, {
      params: paramsData
    });
  },
  //线下课堂签到
  offlineSign(paramsData) {
    return axios.post(`/develop/offline/sign`, paramsData);
  },
  //线下课堂评分
  offlineEvaluate(paramsData) {
    return axios.post(`/develop/offline/evaluate`, paramsData);
  },
  //线下课堂评分详情
  evaluateDetail(paramsData) {
    return axios.get(`/develop/offline/evaluateDetail`, { params: paramsData });
  },
  //勋章查询
  queryMedal(paramsData) {
    return axios.get(`/develop/my/staff/medal`, { params: paramsData });
  },
  //成就榜单查询
  queryStaffMedalData(paramsData) {
    return axios.get(`/develop/my/staff/medalTopList`, { params: paramsData });
  },
  //信息共享
  expandInfoShareList(paramsData) {
    return axios.post(`/develop/expandInfoShare/list`, paramsData);
  },
  //信息共享全部已读
  expandInfoShareAllRead(paramsData) {
    return axios.post(`/develop/expandInfoShare/allRead`, paramsData);
  },
  //信息共享单个已读
  expandInfoShareRead(paramsData) {
    return axios.post(`/develop/expandInfoShare/read`, paramsData);
  },
  //项目评估历史评估记录
  projectDataScoreScoreList(paramsData) {
    return axios.get(`/develop/projectDataScore/scoreList`, {
      params: paramsData
    });
  },
  //删除竞争对手关联项目
  sameIndustryDelProject(paramsData) {
    return axios.get(`/develop/sameIndustry/delProject`, {
      params: paramsData
    });
  },
  //获取公司列表
  selectAllCompany(paramsData) {
    return axios.get(`/develop/company/selectAllCompany`, {
      params: paramsData
    });
  },
  //获取所有项目
  getAllSaleHistory(paramsData){ ///develop/project/manage/saleHistory
    return axios.post(`/develop/project/manage/saleHistory`,paramsData);

  },
  //合作信息
  cooperateBoard(paramsData) {
    return axios.get(`/develop/cooperate/board`, { params: paramsData });
  },
  //合作开发商
  cooperateDeveloperList(paramsData) {
    return axios.post(`/develop/cooperate/developerList`, paramsData);
  },
  //根据开发商id查询项目（省-市维度）
  queryProjectByDeveloperId(paramsData) {
    return axios.get(`/develop/cooperate/queryProjectByDeveloperId`, {
      params: paramsData
    });
  },
  //合作项目
  cooperateProjectList(paramsData) {
    return axios.post(`/develop/cooperate/projectList`, paramsData);
  },
  //合作项目详情
  cooperateProjectDetail(paramsData) {
    return axios.get(`/develop/cooperate/projectDetail`, {
      params: paramsData
    });
  },
  //获取历史评估
  getHistoryReplayList(paramsData) {
    return axios.get(`/develop/project/inferAndReplay/historyReplayList`, {
      params: paramsData
    });
  },
  //储备项目列表
  getReserveProject(paramsData) {
    return axios.post(`/develop/project/spare/list`, paramsData);
  },
  //保存储备项目
  saveReserveProject(paramsData) {
    return axios.post(`/develop/project/spare/save`, paramsData);
  },
  //储备项目作废
  voidReserveProject(paramsData) {
    return axios.post(`/develop/project/spare/cancel`, paramsData);
  },
  //储备项目修改记录
  getReserveProjectEditRecord(paramsData) {
    return axios.get(`/develop/project/spare/updateRecord`, {
      params: paramsData
    });
  },
  //储备项目列表统计 /develop/project/spare/statistics
  getSpareStatistic(paramsData) {
    return axios.post(`/develop/project/spare/statistics`, paramsData);
  },
  //会议列表
  getMeetingList(paramsData) {
    return axios.get(`/develop/meeting/get`, { params: paramsData });
  },
  //获取物品类型
  getGoodsType(paramsData) {
    return axios.get(`/develop/borrow/getType`, { params: paramsData });
  },
  //决策链修改
  updateDecision(paramsData) {
    return axios.post(`/develop/resource/manage/updateDecision`, paramsData);
  },
  //删除资源跟进记录
  resourceFollowDelete(paramsData) {
    return axios.post(`/develop/resource/follow/delete`, paramsData);
  },
  //通话记录标记
  manageMarkCall(paramsData) {
    return axios.post(`/develop/resource/manage/markCall`, paramsData);
  },
  //我的通话记录
  mySelectSoundRecord(paramsData) {
    return axios.post(`/develop/soundRecord/selectSoundRecord`, paramsData);
  },
  //呼叫中心-选择开发商列表
  getDeveloperList(paramsData) {
    return axios.get(`/develop/developer/query/selectDeveloperList`, {
      params: paramsData
    });
  },
  //发起查询
  launchQuery(paramsData) {
    return axios.post(`/develop/developer/query/launch`, paramsData);
  },
  //呼叫中心列表
  getCallCenterList(paramsData) {
    return axios.get(`/develop/developer/query/list`, { params: paramsData });
  },
  //呼叫详情
  queryCallDetails(paramsData) {
    return axios.get(`/develop/developer/query/resourceListByQueryId`, {
      params: paramsData
    });
  },
  //保存反馈结果
  saveFeedback(paramsData) {
    return axios.post(`/develop/developer/query/call/saveFeedback`, paramsData);
  },
  //地方政策
  allRegionPolicyList(paramsData) {
    return axios.get(`/develop/region/policy/ai/allRegionPolicyList`, {
      params: paramsData
    });
  }, //develop/region/policy/ai/allRegionPolicyList
  //根据地区查政策
  listByRegion(paramsData) {
    return axios.get(`/develop/region/policy/listByRegion`, {
      params: paramsData
    });
  },
  //新增政策
  addPolicy(paramsData) {
    return axios.post(`/develop/region/policy/add`, paramsData);
  },
  //修改政策
  updatePolicy(paramsData) {
    return axios.post(`/develop/region/policy/update`, paramsData);
  },
  //作废政策
  cancelPolicy(paramsData) {
    return axios.post(`/develop/region/policy/cancel`, paramsData);
  },
  //获取工单列表
  getWorkOrder(paramsData) {
    return axios.get(`/develop/workOrder/mySendList`, { params: paramsData });
  },
  //发起工单
  addWorkOrder(paramsData) {
    return axios.post(`/develop/workOrder/launch`, paramsData);
  },
  //工单详情
  workOrderDetail(paramsData) {
    return axios.get(`/develop/workOrder/detail`, { params: paramsData });
  },
  //获取开发商详情
  getDeveloperDetailLXR(paramsData) {
    return axios.get(`/develop/developer/query/detail`, { params: paramsData });
  },
  //获取开发商详情
  getPropertyDetailLXR(paramsData) {
    return axios.get(`/develop/developer/query/property/detail`, {
      params: paramsData
    });
  },
  //查询联系人
  developerQueryDaas(paramsData) {
    return axios.post(`/develop/developer/query/queryDaas`, paramsData);
  },
  //获取公司所有人员
  getAllSelectStaff(paramsData) {
    return axios.get(`/develop/borrow/selectStaff`, { params: paramsData });
  },
  //获取发票报销类型
  reimbursementTypeListNew(paramsData) {
    return axios.get("/develop/reimbursement/staffReimbursementTypeList", {
      params: paramsData
    });
  },
  //修改项目联系人开发商和物业
  updateProjectDeveloperAndProperty(paramsData) {
    return axios.post(
      `/develop/project/manage/updateProjectDeveloperAndProperty`,
      paramsData
    );
  },
  //拓展流程
  getSopDetail(paramsData) {
    return axios.get("/develop/project/sop/detail", { params: paramsData });
  },
  //拓展流程
  saveSopValue(paramsData) {
    return axios.post(`/develop/project/sop/saveSopValue`, paramsData);
  },
  //结算状态修改
  updateStatusSettlement(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/updateStatus",
      paramsData
    );
  },
  //抄送已读
  actReadCc(paramsData) {
    return axios.post("/develop/act/readCc", paramsData);
  },
  //保存项目车位图片
  addParkImage(paramsData) {
    return axios.post("/develop/project/manage/saveParkImg", paramsData);
  },
  //申请资源共享
  applyShareResource(paramsData) {
    return axios.post("/develop/resource/manage/applyShare", paramsData);
  },
  //申请资源共享详情
  applyShareDetail(paramsData) {
    return axios.get("/develop/resource/manage/applyShare/detail", {
      params: paramsData
    });
  },
  //申请资源共享审核
  applyShareCheck(paramsData) {
    return axios.post("/develop/resource/manage/applyShare/check", paramsData);
  },
  //获取今日行为统计
  getActionStatistics(paramsData) {
    return axios.get("/develop/dailyReport/getActionStatistics", {
      params: paramsData
    });
  },
  //新增日报 /develop/dailyReport/add
  addDailyReport(paramsData) {
    return axios.post("/develop/dailyReport/add", paramsData);
  },
  //修改日报 /develop/dailyReport/update
  updateDailyReport(paramsData) {
    return axios.post("/develop/dailyReport/update", paramsData);
  },
  //日报列表 /develop/dailyReport/list
  dailyReportList(paramsData) {
    return axios.get("/develop/dailyReport/list", { params: paramsData });
  },
  // 日报详情 /develop/dailyReport/detail
  dailyReportDetail(paramsData) {
    return axios.get("/develop/dailyReport/detail", { params: paramsData });
  },
  //是否写日志 /develop/dailyReport/isWrite
  isWriteDailyReport(paramsData) {
    return axios.get("/develop/dailyReport/isWrite", { params: paramsData });
  },
  //抄送一键已读
  readAllCc(paramsData) {
    return axios.post("/develop/act/readAllCc", paramsData);
  },
  //标记资源在职离职
  resourceMarkResign(paramsData) {
    return axios.post("/develop/resource/manage/markResign", paramsData);
  },
  //获取存量拓展
  selectDeveloper(paramsData) {
    return axios.get(`/develop/pressMoney/selectDeveloper`, {
      params: paramsData
    });
  },
  //朋友圈素材列表
  friendCircleMaterialList(paramsData) {
    return axios.get(`/develop/friendsCircle/get`, { params: paramsData });
  },
  //获取数据表新
  dataSheetDetail(paramsData) {
    return axios.get(`/develop/project/dataSheet/detail`, {
      params: paramsData
    });
  },
  //保存数据表新
  dataSheetUpdate(paramsData) {
    return axios.post("/develop/project/dataSheet/update", paramsData);
  },
  //获取实勘列表
  getSiteVisitList(paramsData) {
    return axios.get(`/develop/project/siteVisit/list`, { params: paramsData });
  },
  //保存实勘数据
  siteVisitSave(paramsData) {
    return axios.post("/develop/project/siteVisit/save", paramsData);
  },
  //结束实勘数据
  siteVisitOver(paramsData) {
    return axios.post("/develop/project/siteVisit/over", paramsData);
  },
  //获取实勘详情
  getSiteVisitDetail(paramsData) {
    return axios.get(`/develop/project/siteVisit/detail`, {
      params: paramsData
    });
  },
  //根据区域获取该区域的拓展负责人
  getAreaExtendManager(paramsData) {
    return axios.get(`/develop/project/manage/projectStaffIdByRegion`, {
      params: paramsData
    });
  },
  //修改客户信息
  updateNonCooperationReason(paramsData) {
    return axios.post(
      "/develop/developer/group/updateNonCooperationReason",
      paramsData
    );
  },
  //获取swot总结
  swotSummarizeSubGet(paramsData) {
    return axios.get(`/develop/project/dataSheet/swot/summarize`, {
      params: paramsData
    });
  },
  //保存swot总结
  swotSummarizeSub(paramsData) {
    return axios.post("/develop/project/dataSheet/swot/summarize", paramsData);
  },
  //获取swot配置规则
  getSwotConfig(paramsData) {
    return axios.get(`/develop/project/dataSheet/swot/config`, {
      params: paramsData
    });
  },
  //获取公域资源列表
  getChannelList(paramsData) {
    return axios.get(`/develop/resource/channel/list`, { params: paramsData });
  },
  //反馈公域资源
  channelFeedback(paramsData) {
    return axios.post("/develop/resource/channel/feedback", paramsData);
  },
  //获取公域资源待反馈数量
  getWaitFeedbackNum(paramsData) {
    return axios.get(`/develop/resource/channel/waitFeedbackNum`, {
      params: paramsData
    });
  },
  //获取结算修改记录
  getSettlementUpdateRecord(paramsData) {
    return axios.get(
      base.settlementUrl + `/settlement/settlement/updateRecord`,
      { params: paramsData }
    );
  },
  //获取结算车位楼层
  getCurrentSettlementList(paramsData) {
    return axios.post(
      base.settlementUrl + "/settlement/settlement/getCurrentSettlementList",
      paramsData
    );
  },
  //统计v2
  statisticsExpand(paramsData) {
    return axios.get(`/develop/statistics/expand`, { params: paramsData });
  },
  //统计项目v2
  statisticsProject(paramsData) {
    return axios.get(`/develop/statistics/project`, { params: paramsData });
  },
  //统计资源v2
  statisticsResource(paramsData) {
    return axios.get(`/develop/statistics/resource`, { params: paramsData });
  },
  //根据地区查政策Ai
  listByRegionAi(paramsData) {
    return axios.get(`/develop/region/policy/ai/regionPolicyDetail`, {
      params: paramsData
    });
  },
  //获取免登录北森
  getFreeLoginUrlNew(paramsData) {
    return axios.get("/develop/beiSen/userSso", { params: paramsData });
  },
  //未来14天表列表
  getExpandScheduleList(paramsData) {
    return axios.get("/develop/expandSchedule/list", { params: paramsData });
  },
  //获取未来14天表详情
  getExpandSchedule(paramsData) {
    return axios.get("/develop/expandSchedule/detail", { params: paramsData });
  },
  //新增未来14天表
  expandScheduleAdd(paramsData) {
    return axios.post("/develop/expandSchedule/add", paramsData);
  },
  //修改未来14天表状态
  expandScheduleChangeState(paramsData) {
    return axios.post("/develop/expandSchedule/changeState", paramsData);
  },
  //修改未来14天表详情
  expandScheduleUpdate(paramsData) {
    return axios.post("/develop/expandSchedule/update", paramsData);
  },
  //新增会议策略
  addMeetingDecision(paramsData) {
    return axios.post("/develop/project/manage/addMeetingDecision", paramsData);
  },
  //项目详情-项目分析-提示
  getManagePrompt(paramsData) {
    return axios.get("/develop/project/manage/prompt", { params: paramsData });
  },
  //获取公域资源详情
  getChannelDetail(paramsData) {
    return axios.get("/develop/resource/channel/detail", {
      params: paramsData
    });
  },
  //获取客户列表(全国)
  getExpandCustomerList(paramsData) {
    return axios.get("/develop/expandCustomer/list", { params: paramsData });
  },
  //新增客户
  expandCustomerSave(paramsData) {
    return axios.post("/develop/expandCustomer/save", paramsData);
  },
  //获取客户详情
  getExpandCustomerBase(paramsData) {
    return axios.get("/develop/expandCustomer/base", { params: paramsData });
  },
  //客户跟进
  expandCustomerFollow(paramsData) {
    return axios.post("/develop/expandCustomer/follow", paramsData);
  },
  //获取客户详情
  getExpandCustomerFollowRecord(paramsData) {
    return axios.get("/develop/expandCustomer/followRecord", {
      params: paramsData
    });
  },
  //客户关联
  expandCustomerLink(paramsData) {
    return axios.post("/develop/expandCustomer/link", paramsData);
  },
  //获取客户关联资源
  getExpandCustomerResource(paramsData) {
    return axios.get("/develop/expandCustomer/resource", {
      params: paramsData
    });
  },
  //获取客户关联项目
  getExpandCustomerProject(paramsData) {
    return axios.get("/develop/expandCustomer/project", { params: paramsData });
  },
  //获取客户关联开发商
  getExpandCustomerDeveloper(paramsData) {
    return axios.get("/develop/expandCustomer/developer", {
      params: paramsData
    });
  },
  //取消客户关联
  expandCustomerCancelLink(paramsData) {
    return axios.post("/develop/expandCustomer/cancelLink", paramsData);
  },
  //客户关联记录
  getExpandCustomerLinkRecord(paramsData) {
    return axios.get("/develop/expandCustomer/linkRecord", {
      params: paramsData
    });
  },
  //删除客户
  expandCustomerDelete(paramsData) {
    return axios.post("/develop/expandCustomer/delete", paramsData);
  },
  //获取项目关联的客户
  getExpandCustomerListByProjectId(paramsData) {
    return axios.get("/develop/expandCustomer/listByProjectId", {
      params: paramsData
    });
  },
  //获取资源关联的客户
  getExpandCustomerListByResourceId(paramsData) {
    return axios.get("/develop/expandCustomer/listByResourceId", {
      params: paramsData
    });
  },
  //获取客户列表（选择）
  expandCustomerSimpleList(paramsData) {
    return axios.get("/develop/expandCustomer/simpleList", {
      params: paramsData
    });
  },
  //获取用友银行网点数据
  getYonYouBankDotList(paramsData) {
    return axios.get(`/develop/externalCollectionAccount/yonYouBankDotList`, {
      params: paramsData
    });
  },
  //根据开发商id查询未关联的资源及项目
  queryNonSyncLinkByDeveloperId(paramsData) {
    return axios.get(`/develop/expandCustomer/queryNonSyncLinkByDeveloperId`, {
      params: paramsData
    });
  },
  //根据项目id查询未关联的资源及开发商
  queryNonSyncLinkByProjectId(paramsData) {
    return axios.get(`/develop/expandCustomer/queryNonSyncLinkByProjectId`, {
      params: paramsData
    });
  },
  //根据资源id查询未关联的项目及开发商
  queryNonSyncLinkByResourceId(paramsData) {
    return axios.get(`/develop/expandCustomer/queryNonSyncLinkByResourceId`, {
      params: paramsData
    });
  },
  //根据资源id查询项目关联的客户
  getListByProjectResourceId(paramsData) {
    return axios.get(`/develop/expandCustomer/listByProjectResourceId`, {
      params: paramsData
    });
  },
  //获取客户列表
  getExpandCustomerListV2(paramsData) {
    return axios.get("/develop/expandCustomer/listV2", { params: paramsData });
  },
  //OA批量审核
  completeBatchMore(paramsData) {
    return axios.post(`/develop/act/complete/batch`, paramsData);
  },
  //取消共享资源
  cancelShareSelf(paramsData) {
    return axios.post(`/develop/resource/manage/cancelShareSelf`, paramsData);
  },
  //客户资源身份备注
  changeModifyResourceIdentityRemark(paramsData) {
    return axios.post(
      `/develop/expandCustomer/modifyResourceIdentityRemark`,
      paramsData
    );
  },
  //客户资源身份备注
  expandCustomerMerge(paramsData) {
    return axios.post(`/develop/expandCustomer/merge`, paramsData);
  },
  //获取名片信息
  selectStaffCard(paramsData) {
    return axios.get("/develop/my/staff/selectStaffCard", {
      params: paramsData
    });
  },
  //保存名片信息
  saveStaffCard(paramsData) {
    return axios.post(`/develop/my/staff/saveStaffCard`, paramsData);
  },
  //获取客户整合跟进记录
  getLinkFollowRecord(paramsData) {
    return axios.get("/develop/expandCustomer/linkFollowRecord", {
      params: paramsData
    });
  },
  //微信小程序动态列表
  getWeChatUserList(paramsData) {
    return axios.get("/develop/my/staff/weChatUserList", {
      params: paramsData
    });
  },
  //微信小程序用户动态待办数量
  getWeChatUserWaitCount(paramsData) {
    return axios.get("/develop/my/staff/weChatUserWaitCount", {
      params: paramsData
    });
  },
  //微信小程序用户动态阅读状态设置
  weChatUserReadStatus(paramsData) {
    return axios.post(`/develop/my/staff/weChatUserReadStatus`, paramsData);
  },
  //微信小程序动态编辑
  updateWeChatUser(paramsData) {
    return axios.post(`/develop/my/staff/updateWeChatUser`, paramsData);
  },
  //客户关联项目分享
  expandCustomerShare(paramsData) {
    return axios.post(`/develop/expandCustomer/share`, paramsData);
  },
  //客户关联项目分享-待办确认
  expandCustomerShareConfirm(paramsData) {
    return axios.post(`/develop/expandCustomer/share/confirm`, paramsData);
  },
  //客户关联项目分享-确认提交
  expandCustomerShareSave(paramsData) {
    return axios.post(`/develop/expandCustomer/share/save`, paramsData);
  },
  //客户关联项目分享详情
  expandCustomerShareDetail(paramsData) {
    return axios.get("/develop/expandCustomer/share/detail", {
      params: paramsData
    });
  },
  //问卷代办-确认提交
  sureQuestionSure(paramsData) {
    return axios.post(`/develop/question/questionSure`, paramsData);
  },
  //开发商接待列表
  getDeveloperReceiveList(paramsData) {
    return axios.get("/develop/developer/receive/list", { params: paramsData });
  },
  //开发商接待详情
  getReceiveDetail(paramsData) {
    return axios.get("/develop/developer/receive/detail", {
      params: paramsData
    });
  },
  //开发商接待添加编辑
  saveReceiveDetail(paramsData) {
    return axios.post(`/develop/developer/receive/save`, paramsData);
  },
  //开发商接待评分
  saveReceiveDetailEvaluate(paramsData) {
    return axios.post(`/develop/developer/receive/evaluate`, paramsData);
  },
  //开发商待处理红点
  getReceiveRemind(paramsData) {
    return axios.post(`/develop/developer/receive/remind`, paramsData);
  },
  //新增客户计划
  workPlanAdd(paramsData) {
    return axios.post(`/develop/expand/workPlan/add`, paramsData);
  },
  //客户计划修改状态
  workPlanChangeState(paramsData) {
    return axios.post(`/develop/expand/workPlan/changeState`, paramsData);
  },
  //客户计划根据客户id查询最近一次计划
  workPlanQueryLastWorkPlanByCustomerId(paramsData) {
    return axios.get("/develop/expand/workPlan/queryLastWorkPlanByCustomerId", {
      params: paramsData
    });
  },
  //客户计划修改
  workPlanUpdate(paramsData) {
    return axios.post(`/develop/expand/workPlan/update`, paramsData);
  },
  //客户计划列表
  getWorkPlanList(paramsData) {
    return axios.get("/develop/expand/workPlan/list", { params: paramsData });
  },
  //客户计划详情
  getWorkPlanDetail(paramsData) {
    return axios.get("/develop/expand/workPlan/detail", { params: paramsData });
  },
  //客户计划红点数量
  getWorkPlanRemind(paramsData) {
    return axios.get("/develop/expand/workPlan/remind", { params: paramsData });
  },
  //token刷新
  refreshToken(paramsData) {
    return axios.post(`/develop/refreshToken`, paramsData);
  },
  //统计-面谈列表
  staticInterviewList(paramsData) {
    return axios.get("/develop/statistics/expand/interviewList", {
      params: paramsData
    });
  },
  //统计-通话资源列表
  staticcallListList(paramsData) {
    return axios.get("/develop/statistics/expand/callList", {
      params: paramsData
    });
  },
  //客户计划-根据客户id查询未完成计划数量
  queryNonFinishWorkPlanNumByCustomerId(paramsData) {
    return axios.get(
      "/develop/expand/workPlan/queryNonFinishWorkPlanNumByCustomerId",
      { params: paramsData }
    );
  },
  //客户计划-查询日历（每天任务统计）
  getWorkPlanQueryCalendar(paramsData) {
    return axios.get("/develop/expand/workPlan/queryCalendar", {
      params: paramsData
    });
  },
  //客户计划修改记录
  getWorkPlanUpdateLog(paramsData) {
    return axios.get("/develop/expand/workPlan/updateLog", {
      params: paramsData
    });
  },
  //定稿作废
  contractDraftCancel(paramsData) {
    return axios.post(`/develop/contract/draft/cancel`, paramsData);
  },
  //推荐资源
  getRecommendList(paramsData) {
    return axios.get("/develop/resource/recommend/list", {
      params: paramsData
    });
  },
  //内部推荐资源
  getInternalRecommendList(paramsData) {
    return axios.get("/develop/resource/internal/recommend/list", {
      params: paramsData
    });
  },
  //保存资源推荐
  recommendSave(paramsData) {
    return axios.post(`/develop/resource/recommend/save`, paramsData);
  },
   //保存内部资源推荐
  internalRecommendSave(paramsData) {
    return axios.post(`/develop/resource/internal/recommend/save`, paramsData);
  },
  //资源推荐详情
  getRecommendDetail(paramsData) {
    return axios.get("/develop/resource/recommend/detail", {
      params: paramsData
    });
  },
  //内部资源推荐详情
  getInternalRecommendDetail(paramsData) {
    return axios.get("/develop/resource/internal/recommend/detail", {
      params: paramsData
    });
  },
  //资源推荐反馈
  recommendFeedback(paramsData) {
    return axios.post(`/develop/resource/recommend/feedback`, paramsData);
  },
   //内部资源推荐反馈
  internalRecommendFeedback(paramsData) {
    return axios.post(`/develop/resource/internal/recommend/feedback`, paramsData);
  },
  //资源推荐红点
  getRecommendRemind(paramsData) {
    return axios.get("/develop/resource/recommend/remind", {
      params: paramsData
    });
  },
  //内部资源推荐红点
  getRecommendRemindInternal(paramsData) {
    return axios.get("/develop/resource/internal/recommend/remind", {
      params: paramsData
    });
  },
  //名片埋点
  staffCardShare(paramsData) {
    return axios.post(`/develop/my/staff/staffCardShare`, paramsData);
  },
  //获取对应人员客户计划
  getPlanLineTypeStatistics(paramsData) {
    return axios.get("/develop/expand/workPlan/planLineTypeStatistics", {
      params: paramsData
    });
  },
  //设置收款账号启用
  externalCollectionAccountSaveStatus(paramsData) {
    return axios.post(
      `/develop/externalCollectionAccount/saveStatus`,
      paramsData
    );
  },
  //获取资源验证红点
  getResourceVerifyRemind(paramsData) {
    return axios.get("/develop/resourceVerify/remind", { params: paramsData });
  },
  //获取资源验证列表
  getResourceVerifyLlist(paramsData) {
    return axios.get("/develop/resourceVerify/list", { params: paramsData });
  },
  //设置验证状态
  resourceVerifyVerify(paramsData) {
    return axios.post(`/develop/resourceVerify/verify`, paramsData);
  },
  //批量新增工作计划
  workPlanBatchAdd(paramsData) {
    return axios.post(`/develop/expand/workPlan/batchAdd`, paramsData);
  },
  //获取客户统计
  getStatisticsCustomer(paramsData) {
    return axios.get("/develop/statistics/customer", { params: paramsData });
  },
  //获取月度目标完成率
  getMonthTargetCompletionRate(paramsData) {
    return axios.get("/develop/expand/monthTarget/completionRate", {
      params: paramsData
    });
  },
  //获取月度目标列表
  getMonthTargetList(paramsData) {
    return axios.get("/develop/expand/monthTarget/list", {
      params: paramsData
    });
  },
  //获取AI对话列表
  getExpandChatHistoryList(paramsData) {
    return axios.get(base.aiPostUrl + "chat/api/expand/chat/historyList", {
      params: paramsData
    });
  },
  //获取AI对话详情
  getExpandChatHistoryDetail(paramsData) {
    return axios.get(base.aiPostUrl + "chat/api/expand/chat/history", {
      params: paramsData
    });
  },
  //获取客户商机详情
  getBusinessDetail(paramsData) {
    return axios.get("/develop/expandCustomer/business/detail", {
      params: paramsData
    });
  },
  //保存客户商机
  saveCustomerBusiness(paramsData) {
    return axios.post(`/develop/expandCustomer/business/save`, paramsData);
  },
  //修改客户商关联项目等级
  changeModifyCustomerProjectValue(paramsData) {
    return axios.post(`/develop/project/manage/updateProjectValue`, paramsData);
  },
  //作废商务条款
  cancelCommerceClause(paramsData) {
    return axios.post(`/develop/commerceClause/cancel`, paramsData);
  },
  // //商务条款共识
  // consensusCommerceClause(paramsData) {
  //     return axios.post(`/develop/commerceClause/consensus`, paramsData);
  // },
  //采购作废
  purchaseCancel(paramsData) {
    return axios.post(`/develop/purchase/cancel`, paramsData);
  },
  //采购通过
  purchaseComplete(paramsData) {
    return axios.post(`/develop/act/purchase/complete`, paramsData);
  },
  //统计看板-首页
  getStatisticsBanner(paramsData) {
    return axios.get("/develop/statistics/banner", { params: paramsData });
  },
  //获取分公司负责人
  getExpandStaffBoss(paramsData) {
    return axios.get("/develop/project/manage/expandStaffBoss", {
      params: paramsData
    });
  },
  //获取面谈录音设备信息 /develop/duDuTalk/staffDeviceInfo
  getRecordingDeviceInfo(paramsData) {
    return axios.get("/develop/duDuTalk/staffDeviceInfo", {
      params: paramsData
    });
  },
  //面谈录音列表 /develop/duDuTalk/audioList
  getAudioList(paramsData) {
    return axios.get("/develop/duDuTalk/audioList", { params: paramsData });
  },
  //设置关联资源 /develop/duDuTalk/setResource
  setResource(paramsData) {
    return axios.post("/develop/duDuTalk/setResource", paramsData);
  },
  //设置录音状态    /develop/duDuTalk/setRecordingStatus
  setRecordingStatus(paramsData) {
    return axios.post("/develop/duDuTalk/setRecordingStatus", paramsData);
  },
  //ai通用get请求
  getDataForAi(paramsData) {
    let url = paramsData.httpUrl;
    delete paramsData.httpUrl;
    return axios.get(url, { params: paramsData });
  },
   //ai通用pot请求
  postDataForAi(paramsData) {
    let url = paramsData.httpUrl;
    delete paramsData.httpUrl;
    return axios.post(url, paramsData);
  },
  //删除录音    /develop/duDuTalk/del
  deleteRecording(paramsData) {
    return axios.post("/develop/duDuTalk/del", paramsData);
  },
  //推荐资源三方列表
  getThirdPartyList(paramsData) {
    return axios.get("/develop/resource/recommend/thirdPartyList", { params: paramsData });
  },
  //修改外部推荐转交人
  updateForwardStaff(paramsData) {
    return axios.post("/develop/resource/recommend/updateForwardStaff", paramsData);
  },
  //修改内部推荐转交人
  updateInternalForwardStaff(paramsData) {
    return axios.post("/develop/resource/internal/recommend/updateForwardStaff", paramsData);
  },
  //ai录音摘要重载
  updateSummary(paramsData) {
    return axios.post("/develop/duDuTalk/updateSummary", paramsData);
  },
   //获取商机详情-项目客户商机
  getProjectBusinessDetail(paramsData) {
    return axios.get("/develop/expandCustomer/project/business/detail", { params: paramsData });
  },
  //获取商机详情-项目客户商机
  saveProjectBusinessDetail(paramsData) {
    return axios.post("/develop/expandCustomer/project/business/update", paramsData);
  },
  //获取商机列表
  getCustomerGroupFourBusinessList(paramsData) {
    return axios.get("/develop/expandCustomer/customerGroupFourBusinessList", { params: paramsData });
  },
  //获取商机积分列表
  getCustomerGroupFourBusinessScoreList(paramsData) {
    return axios.get("/develop/expand/staff/score/list", { params: paramsData });
  },
  //获取商机积分统计
  getCustomerGroupFourBusinessScoreTotal(paramsData) {
    return axios.get("/develop/expand/staff/score/sum", { params: paramsData });
  },
  //智能体应用列表
  getAIAgentList(paramsData) {
      return axios.post(`/develop/aiAgent/aiAgentList`, paramsData);
  },
  //获取商机评审列表
  getExpandCustomerBusinessReviewList(paramsData) {
    return axios.get("/develop/expandCustomer/businessReviewList", { params: paramsData });
  },
  //商机评审
  saveBusinessReview(paramsData) {
    return axios.post("/develop/expandCustomer/businessReview", paramsData);
  },
  //获取商机评审数量
  getcustomerGroupFourBusinessAuditListCount(paramsData) {
    return axios.get("/develop/expandCustomer/businessReviewNum", { params: paramsData });
  },
  //获取客户计划项目当前阶段
  selectLastScoreDimension(paramsData) {
    return axios.post("/develop/expand/staff/score/selectLastScoreDimension", paramsData);
  },
  //获取采集声纹
  getSelectStaffVoiceprint(paramsData) {
    return axios.get("/develop/XunFei/selectStaffVoiceprint", { params: paramsData });
  },
  // 智能体调用保存
  saveMerchantOrderAd(paramsData) {
    return axios.post(`/develop/aiAgent/saveNum`, paramsData);
  },
  //获取所有部门
  getDeptList() {
    return axios.get(`/develop/my/staff/deptList`);
  },
  //获取AI资源对话详情
  getAIResourceDetail(paramsData) {
    return axios.get(base.aiPostUrl + "chat/api/biz/develop/queryBizConversationId", { params: paramsData });
  },
  //保存关联项目 /develop/resource/recommend/relateProject
  saveRelevanceProject(paramsData) {
    return axios.post("/develop/resource/recommend/relateProject", paramsData);
  },
  //资源-修改资源客户在职时间
  updateResourceJobState(paramsData) {
    return axios.post("/develop/expandCustomer/resource/updateJobState", paramsData);
  },
  //获取面谈实勘信息
  getProjectInfoByDuduTalkId(paramsData) {
    return axios.get(base.aiPostUrl + "chat/api/biz/develop/structuredOutPut/extractProjectInfo", { params: paramsData });
  },
  //商机-判断项目是否在合同期限内
  checkContractPeriod(paramsData) {
    return axios.get(`/develop/expandCustomer/project/checkContractPeriod`, { params: paramsData });
  },
  getAllCompany(paramsData) {
    return axios.get("/sale/workbench/getAllCompany", { params: paramsData });
  },
  //判断是否续签项目 develop/contract/draft/isRenew
  judgeProjectIsRenew(paramsData){
    return axios.get("/develop/contract/draft/isRenew", { params: paramsData });
  },
  //内部转账收款账户 内部结算 借款 技术服务
  getInternalTransferAccount(paramsData){
    return axios.get("/develop/paymentApplication/internalTransferCollectionAccount", { params: paramsData });
  },
  //删除商机评审
  deleteBusinessReview(paramsData) {
    return axios.post("/develop/expandCustomer/deleteBusinessReview", paramsData);
  },
   //修改公域资源对接人
  updateThirdPartyForwardStaff(paramsData) {
    return axios.post("/develop/resource/channel/updateForwardStaff", paramsData);
  },
    // 收集项目信息详情
  getQuestionProjectInfoDetail(paramsData) {
    return axios.get(`/develop/question/projectInfoDetail`, { params: paramsData })
  },
  // 保存收集项目信息
  saveQuestionProjectInfo(paramsData) {
    return axios.post(`/develop/question/saveProjectInfo`, paramsData)
  },
  // 获取竞争对手详情
  getSameIndustryDetail(paramsData) {
    return axios.get(`/develop/sameIndustry/v2/detail`, { params: paramsData })
  },


};

export default apis;




// WEBPACK FOOTER //
// ./src/request/apis.js